export default {
    fund: [
        // {
        //       "title": "关于远期合约的定义，以下描述错误的是（　　）。",
        //       "date": "2021、201804",
        //       "question": "A．远期合约是一种标准化的合约\nB．远期合约对买卖双方具有同等的约束力\nC．大宗商品和农产品可以作为远期合约的标的资产\nD．金融远期合约主要包括远期利率合约、远期外汇合约和远期股票合约",
        //       "answer": "A",
        //       "explain": "远期合约是非标准化的合约，即它不在交易所交易，而是交易双方通过谈判后签署的。"
        //   },
        //   {
        //       "title": "关于远期合约，错误的是（　　）。",
        //       "date": "2019",
        //       "question": "A．远期合约是一种标准化合约\nB．远期合约不能形成统一的市场价格，与期货合约相比，市场效率偏低\nC．远期合约流动性通常较差\nD．远期合约是一种最简单的衍生品合约",
        //       "answer": "A",
        //       "explain": "远期合约是非标准化的合约，即它不在交易所交易，而是交易双方通过谈判后签署的。"
        //   },
        //   {
        //       "title": "相比期货，远期合约的市场效率偏低，原因是（　　）。",
        //       "date": "201804",
        //       "question": "A．远期合约无法规避现货价格波动风险\nB．远期合约的理论价格经常与实际价格不相等\nC．远期合约是一种非标准化的合约，没有固定交易场所\nD．远期合约的标的资产通常为大宗商品和农产品以及外汇和利率等金融工具",
        //       "answer": "C",
        //       "explain": "因为远期合约没有固定的、集中的交易场所，不利于市场信息的披露，也就不能形成统一的市场价格，所以远期合约市场的效率偏低。"
        //   },
        //   {
        //       "title": "远期合约和期货合约相比，最主要的优点是（　　）。",
        //       "date": "201705",
        //       "question": "A．远期合约相比而言比较灵活\nB．远期合约的流动性比较好\nC．远期合约的违约风险比较低\nD．远期合约具有固定的交易场所",
        //       "answer": "A",
        //       "explain": "远期合约与期货合约相比，远期合约相对而言比较灵活，这正是远期合约最主要的优点。"
        //   },
        //   {
        //       "title": "期货合约具有标准化的特征，在固定场所交易，是（　　）的替代物。",
        //       "date": "2021",
        //       "question": "A．债券\nB．远期合约\nC．股票\nD．抵押品",
        //       "answer": "B",
        //       "explain": "期货合约随着价格变化而修改合约，它是远期合约的替代物。"
        //   },
        //   {
        //       "title": "某投资者A预测股票市场将下跌，于是卖出当月沪深300股指期货合约，准备指数下跌后买入期指获利。A的操作属于（　　）。",
        //       "question": "A．空头投机\nB．多头投机\nC．多头套保\nD．空头套保",
        //       "answer": "A",
        //       "explain": "在期货合约中，在未来卖出合约标的资产（或者卖出合约标的资产权利）的一方称为空头。"
        //   },
        {
            "title": "关于资产负债表中的信息，下列选项表述均错误的是（　　）。",
            "date": "202405",
            "questions": "I．包含了企业占有资源的数量和性质<br>II．资产项揭示了企业资金的资金来源和财务状况<br>III．表中的信息为分析收入来源性质及稳定性提供了基础，可以为收益把关<br>IV．只要研究负债项即可了解企业短期及长期偿债能力",
            "question": "A．I、II、III\nB．II、III、IV\nC．II、IV\nD．III、IV",
            "answer": "C",
            "explain": "(1) 资产负债表列出了企业占有资源的数量和性质，I正确。\n(2) 资产负债表上的资源为分析收入来源性质及其稳定性提供了基础，故III项正确。\n(3) 资产负债表的资产项可以揭示企业资金的占用情况，负债项则说明企业的资金来源和财务状况，有利于投资者分析企业长期债务或短期债务的偿还能力、是否存在财务困难以及违约风险等。\n(4) 资产负债表可以为收益把关。因此，II、IV项错误。"
        },
        {
            "title": "关于财务报表，以下表述正确的是（　　）。",
            "date": "202306、202302",
            "questions": "I．资产负债表记载的信息为时点数，通常为会计季末、半年末或年末<br>II．分析资产负债表可以了解企业资产要素、偿债能力、资本结构、股东权益结构等信息<br>III．资产负债表的基本逻辑关系一般情况下都成立，但在所有者权益为负时除外<br>IV．资产负债表与利润表及现金流量表从不同角度记录反映企业的经营情况，相互之间关系不大",
            "question": "A．I、II\nB．I、II、III\nC．II、III、IV\nD．I、II、IV",
            "answer": "A",
            "explain": "I项正确：资产负债表报告了企业在某一时点的资产、负债和所有者权益的状况，报告时点通常为会计季末、半年末或年末。II项正确：通过分析企业的资产负债表，能够揭示出企业资产要素的信息、长期或短期偿还债务能力、资本结构是否合理、企业经营稳健与否或经营风险的大小以及股东权益结构状况等。<br>III项错误：按照会计恒等式，资产负债表的基本逻辑关系表述为：资产=负债+所有者权益。当所有者权益为负时，说明资产小于负债。<br>IV项错误：作为“第一会计报表”的资产负债表与利润表和现金流量表密切相关。"
        },
        {
            "title": "想要了解企业某段时期管理费用的信息，需要查看该企业的（　　）。",
            "date": "202306",
            "question": "A．利润表\nB．资产负债表\nC．现金流量表\nD．所有者权益变动表",
            "answer": "A",
            "explain": "利润表的基本结构是收入减去成本和费用等于利润，管理费用属于成本和费用。"
        }, {
            "title": "关于企业的现金流，以下表述错误的是（　　）。",
            "date": "202302",
            "question": "A．经营活动产生的现金流是与生产商品、提供劳务、缴纳税金等直接相关的业务所产生的现金流量\nB．筹资活动产生的现金流反映企业长期资本筹集资金状况\nC．企业净现金流可以通过现金流量表所反映，主要包含经营活动、投资活动和筹资活动产生的现金流\nD．投资活动产生的现金流包括为正常生产经营活动投资的短期资产以及企业再投资所产生的股权与债权",
            "answer": "D",
            "explain": "A项正确：经营活动产生的现金流量是与生产商品、 提供劳务、 缴纳税金等直接相关的业务所产生的现金流量。\nB项正确：筹资活动产生的现金流量反映的是企业长期资本（股票和债券、 贷款等）筹集资金状况。\nC项正确：现金流量表的作用包括反映企业的现金流量， 评价企业未来产生现金净流量的能力；现金流量表的基本结构分为三部分， 即经营活动产生的现金流量、 投资活动产生的现金流量和筹资（也称融资）活动产生的现金流量。\nD项错误：投资活动产生的现金流量包括为正常生产经营活动投资的【长期资产】以及对外投资所产生的股权与债权。",
        },
        {
            "title": "某房地产企业预售商品住宅，开盘当日即收到一亿元现金，商品住宅明年交付，预售活动对该企业报表的影响是（　　）。",
            "questions": "I．资产增加<br>II．负债增加<br>III．权益增加<br>IV．经营性现金流增加<br>V．净利润增加",
            "question": "A．I、III、IV、V\nB．I、II、IV、V\nC．I、III、IV\nD．I、II、IV",
            "answer": "D",
            "explain": "房地产企业预收现金一亿元，资产和负债同时增加，所有者权益不变；因销售商品住宅预收一亿元现金，属于经营性活动产生的现金流，所以经营性现金流增加；预售时不确认收入、不结转经营成本，故不影响净利润。"
        },
        {
            "title": "评价企业盈利能力的比率有很多，除了资产收益率和净资产收益率之外，最常用的还有（　　）。",
            "date": "202405、2022",
            "question": "A．存货周转率\nB．销售利润率（ROS）\nC．流动比率\nD．资产负债率",
            "answer": "B",
            "explain": "评价企业盈利能力的比率有很多，其中最重要的有三种：销售利润率（ROS）、资产收益率（ROA）、净资产收益率（ROE）。"
        },
        {
            "title": "已知某公司的资产负债率为0.5，则其权益乘数为（　　）。",
            "date": "202405",
            "question": "A．2\nB．3\nC．1.5\nD．1",
            "answer": "A",
            "explain": "权益乘数=1/（1-资产负债率）=1／（1-0.5）=2。"
        },
        {
            "title": "关于净资产收益率，以下表述正确的是（　　）。",
            "date": "202405",
            "question": "A．净资产收益率能充分反应企业利用总资产创造利润的能力\nB．净资产收益率能准确衡量公司对股东的财富回报能力\nC．净资产收益率能反应企业中短期的回款能力\nD．净资产收益率总是小于资产收益率",
            "answer": "B",
            "explain": "净资产收益率也称权益报酬率，强调每单位的所有者权益能够带来的利润。其计算公式为：净资产收益率=净利润总额/所有者权益总额。净资产收益率高，说明企业利用其自由资本获利的能力强，投资带来的收益高；净资产收益率低则相反。"
        },
        {
            "title": "当某国的物价不断下跌时，该国的名义利率和实际利率的关系为（　　）。",
            "date": "202306",
            "question": "A．名义利率与实际利率大小关系不确定\nB．名义利率与实际利率相等\nC．名义利率比实际利率低\nD．名义利率比实际利率高",
            "answer": "C",
            "explain": "物价下跌时，如果名义利率不变，实际利率会上升，比如5%－（-2%）=7%。【公式：实际利率=名义利率-通货膨胀】"
        },
        {
            "title": "名义利率为12%，通货膨胀率为8%，则实际利率是（　　）。",
            "date": "202306、2021",
            "question": "A．4%\nB．20%\nC．14%\nD．6%",
            "answer": "A",
            "explain": "实际利率=名义利率－通货膨胀率= 12%－8%= 4%。"
        },
        {
            "title": "关于单利、复利，以下表述正确的是（　　）。",
            "date": "202306、202302",
            "question": "A．按单利方式计息，每经过一个计息周期，要将由本金所生利息加入本金计算下一个计息周期的利息；按复利方式计息，由本金所生利息不加入本金重复计算利息\nB．按单利方式计息，由本金所生利息不加入本金重复计算利息；按复利方式计息，每经过一个计息周期，要将由本金所生利息加入本金计算下一个计息周期的利息\nC．按单利或者复利计息，每经过一个计息周期，均要将由本金所生利息加入本金计算下一个计息周期的利息\nD．按单利或者复利计息，由本金所生利息均不加入本金重复计算利息",
            "answer": "B",
            "explain": "按单利方式计息，由本金所生利息不加入本金重复计算利息，故A错误、B正确；如果按复利方式计息，每经过一个计息周期，要将由本金所生利息加入本金计算下一个计息周期的利息， CD错误。"
        },
        {
            "title": "即期利率与远期利率的区别在于（　　）。",
            "date": "202302、2022",
            "question": "A．计息方式不同\nB．收益不同\nC．计息日起点不同\nD．适用的债券种类不同",
            "answer": "C",
            "explain": "远期利率和即期利率的区别在于计息日起点不同，即期利率的起点在当前时刻，而远期利率的起点在未来某一时刻。"
        },
        {
            "title": "如果当前1年和2年的即期利率分别为7%和8%，那么f1,2利率为（　　）。",
            "date": "2023、2021",
            "question": "A．7.5%\nB．9%\nC．15%\nD．1%",
            "answer": "B",
            "explain": "(1+7%) × (1+ f1,2) = (1+8%)²，则有，f1,2 =1.08×1.08/1.07-1≈9.01%"
        },
        {
            "title": "某基金管理人统计了某个基金产品100个交易日的每天净值变化基点值△（单位点），并将△从小到大依次排列分别为△（1）～△（100），其中，△（91）～△（100）为15.75，16.34，16.78，16.85，17.12，17.56，18.41，18.57，18.87，18.99，则△的上2.5%分位数为（　　）。",
            "date": "202306",
            "question": "A．16.78\nB．18.72\nC．16.56\nD．16.34",
            "answer": "B",
            "explain": "上分位数：从大到小排；下分位数：从小到大排。上2.5%分位数，是从大到小数15.75，16.34，16.78，16.85，17.12，17.56，18.41，18.57，18.87，18.99倒数第2.5位，即：(18.57+18.87) ÷2=18.72"
        },
        {
            "title": "关于方差和标准差，以下说法错误的是（　　）。",
            "date": "2022",
            "question": "A．方差为σ²，则标准差为σ\nB．方差通常应用于分析投资收益率，但不可以用来研究价格指数、股指等的波动情况\nC．对于投资收益率r，方差σ²=E[（r－Er）²]\nD．对于r分布未知的情况，可以抽取样本r1，r2，…rn，用其样本s²来估计σ²",
            "answer": "B",
            "explain": "方差除了应用于分析投资收益率，还可以用来研究价格指数、股指等的波动情况。"
        },
        {
            "title": "关于债权资本与权益资本的投票权，以下表述错误的是（　　）。",
            "date": "202306",
            "question": "A．普通股股东一般按照其持股比例享有投票权\nB．通常公司债权方对公司事务没有投票权\nC．通常债券持有者对公司事务没有投票权\nD．优先股股东一般按照其持股比例享有投票权",
            "answer": "D",
            "explain": "D错误：普通股按持股比例享有投票权，优先股没有投票权。"
        },
        {
            "title": "某公司的总资本100万元，其中债权资本和权益资本分别为50万元，公司股东A持有20万元的债权资本和30万元的权益资本，则股东A投票权比例通常为（　　）。",
            "date": "202302",
            "question": "A．60%\nB．100%\nC．30%\nD．50%",
            "answer": "A",
            "explain": "只有普通股股东才有投票权，公司权益资本为50万，A股东持股30万，即占比30÷50=60%"
        },
        {
            "title": "某机构希望在F公司盈利较多时，获得较高的股利收益，则一般情况下，该机构应该投资F公司发行的哪种金融工具？（　　）",
            "date": "2021",
            "question": "A．非累积优先股\nB．普通股\nC．累积优先股\nD．长期债券",
            "answer": "B",
            "explain": "在公司盈利较多时，普通股股东可获得较高的股利收益；优先股股东只能获得固定股息；债券持有者只能获得固定利息。"
        },
        {
            "title": "关于股票价格，以下表述正确的有（　　）。",
            "date": "202306",
            "questions": "I．股票的理论价格是对未来收益的评定<br>II．股票的理论价格与一定的利率水平有关<br>III．股票的价格由股票的账面价值决定<br>IV．发行价格高于票面价值称为折价发行",
            "question": "A．I、II\nB．II、III\nC．III、IV\nD．I、IV",
            "answer": "A",
            "explain": "股票价格就是对未来收益的评定，故I正确。股票及其他有价证券的理论价格就是以一定利率计算出来的未来收入的现值，故II正确。股票的内在价值决定股票的理论价格，故III错误；发行人以低于债券面额的价格出售债券，即折价发行，故IV错误。"
        },
        {
            "title": "关于股票账面价值，以下表述错误的是（　　）。",
            "date": "202306",
            "question": "A．股票的账面价值是股票投资价值分析的重要指标\nB．股票的账面价值又称股票净值或每股净资产\nC．在有优先股的情况下，每股账面价值以公司净资产除以发行在外的普通股票的股数求得\nD．股票的账面价值是每股股票所代表的实际资产的价值",
            "answer": "C",
            "explain": "账面价值是股票投资价值分析的重要指标，在计算公司的净资产收益率时也有重要的作用，故A正确；股票的账面价值又称股票净值或每股净资产，是每股股票所代表的实际资产的价值，BD正确。在没有优先股的条件下，每股账面价值以公司净资产除以发行在外的普通股票的股数求得，故C错误。"
        },
        {
            "title": "（　　）是指在一国证券市场上流通的代表外国公司有价证券的可转让凭证。",
            "date": "2022",
            "question": "A．存托凭证\nB．可转换债券\nC．权证\nD．大额可转让存单",
            "answer": "A",
            "explain": "存托凭证是在一国证券市场上流通的代表外国公司有价证券的可转让凭证。"
        },
        {
            "title": "关于可转换债券特征和要素，以下表述正确的是（　　）。",
            "date": "202302、2021",
            "question": "A．可转换债券的票面利率一般高于同等条件的普通债券的票面利率\nB．可转换债券的双重选择权是指转股权和提前赎回权\nC．可转换债券一般每月付息一次\nD．在转股前，可转换债券体现了持有者与发行公司之间的所有权关系",
            "answer": "B",
            "explain": "可转换债券的票面利率是指可转换债券作为债券的票面年利率，它一般低于相同条件的普通债券的票面利率，因为可转换债券持有者有特殊的选择权，故A错误。可转换债券有双重选择权，对于投资者来说，拥有转股权，可自行选择是否转股，可转换债券是一种较低债息收益和转股权组合的证券；对于发行人来说，拥有提前赎回的权利，可自行选择是否提前赎回，可转换债券是一种较高债息成本（相比没有赎回条款的债券而言）和提前赎回权组合的证券，故B正确。可转换债券应半年或1年付息1次，故C错误。D错误：转股后可转债持有者变成公司股东，体现所有权关系。"
        }, {
            "title": "关于可转债的回售条款，下面说法正确的是（　　）。",
            "date": "202306",
            "question": "A．回售价格根据回售时标的股票市价确定\nB．回售条款由发行人行使\nC．股票下跌时可转债发行人可以行使回售条款\nD．回售条款由可转债持有人行使",
            "answer": "D",
            "explain": "回售条款是指可转债持有者有权在约定的条件触发时按照事先约定的价格将可转债卖回给发行企业的规定。"
        },
        {
            "title": "认购权证持有人在行使权利时，需要支付的金额是（　　）。",
            "question": "A．权证数量×折扣比例×行权价格\nB．权证数量×行权比例×股票价格\nC．权证数量×折扣比例×股票价格\nD．权证数量×行权比例×行权价格",
            "answer": "D",
            "explain": "行权比例指单位权证可以购买或出售标的证券的数量；行权价格是发行权证时约定的权证持有人行权时向发行人购买或出售标的资产的价格。"
        },
        {
            "title": "以下权证不是按行权时间分类的是（　　）。",
            "question": "A．欧式权证\nB．备兑权证\nC．美式权证\nD．百慕大式权证",
            "answer": "B",
            "explain": "备兑权证是按照基础资产的来源不同进行的分类，由投资银行发行。1．欧式权证：只能在约定的到期日当天行权。2．美式权证：在到期日之前的任意时刻都可以行权。3．百慕大式权证：在失效日之前一段规定时间内行权。"
        },
        {
            "title": "下列几种情况，不属于再融资的是（　　）。",
            "question": "A．配股\nB．增发\nC．定向增发\nD．送股",
            "answer": "D",
            "explain": "送股属于发放股票股利，故D选项不属于再融资。"
        },
        {
            "title": "公司出现（　　）情况时，可以回购该公司股票。",
            "questions": "I．减少注册资本<br>II．与持有该公司股份的其他公司合并<br>III．公司分立<br>IV．将股份奖励给职工",
            "question": "A．I、III、IV\nB．I、II、III\nC．II、III、IV\nD．I、II、IV",
            "answer": "D",
            "explain": ""
        },
        {
            "title": "下列选项中，不属于技术分析的三项假定的是（　　）。",
            "date": "202306",
            "question": "A．历史会重演\nB．市场行为涵盖一切信息\nC．股票的市场价格围绕其内在价值波动\nD．股价具有趋势性运动规律",
            "answer": "C",
            "explain": "技术分析的三项假定分别是：（1）市场行为涵盖一切信息，B正确；（2）股价具有趋势性运动规律，股票价格沿趋势运动；（3）历史会重演，故AD正确。（4）C不是技术分析，它是一种现象。"
        },
        {
            "title": "关于股票基本面分析和技术分析，以下表述错误的是（　　）。",
            "date": "202306",
            "question": "A．基本面分析的核心在于公司未来的经营业绩和盈利水平\nB．技术分析不仅关心证券市场本身的变化也会考虑基本面因素\nC．技术分析主要研究股价、成交量、图形走势、涨跌幅等因素\nD．基本面分析主要研究宏观经济、行业状况和公司价值等因素",
            "answer": "B",
            "explain": "公司未来的经营业绩和盈利水平是基本面分析的核心所在，A正确。技术分析只关心证券市场本身的变化，而不考虑基本面因素，B错误；技术分析则是通过股价、成交量、涨跌幅、图形走势等研究市场行为，以推测未来价格的变动趋势，故C正确；基本面分析对经济情况、行业动态以及各个公司的经营管理状况等因素进行分析，以此来研究股票的价值，衡量股价的高低，D正确。"
        },
        {
            "title": "（　　）是传统业绩衡量指标体系的重要补充。",
            "date": "202306",
            "question": "A．经济附加值指标\nB．资金成本指标\nC．净利润指标\nD．现金流指标",
            "answer": "A",
            "explain": "20世纪90年代中期以后，EVA经济附加值模型逐渐在国外获得广泛应用，成为传统业绩衡量指标体系的重要补充。"
        },
        {
            "title": "关于内在价值法，以下表述错误的是（　　）。",
            "date": "202302",
            "question": "A．一般情况下，内在价值等于股票当前价格\nB．内在价值法是按照未来现金流贴现对公司的内在价值进行评估\nC．贴现模型的选择要与获得的现金流相对应\nD．股利贴现模型、股权资本自由现金流贴现模型、自由现金流贴现模型都属于内在价值法",
            "answer": "A",
            "explain": "A错误、BC正确：内在价值法又称绝对价值法或收益贴现模型，是按照未来现金流的贴现对公司的内在价值进行评估，所以并不是直接等于】股票的当前价格，是要以一定的折现率，将股票未来的现金流进行折现到现再的价值。D正确：内在价值法又分为股利贴现模型（DDM）、自由现金流量贴现模型（DCF）、经济附加值模型等。"
        },
        {
            "title": "可用于市现率模型估值的现金流包括（　　）。",
            "date": "202306",
            "questions": "I．EBITDA<br>II．营运现金流<br>III．自由现金流",
            "question": "A．I、III\nB．I\nC．II、III\nD．I、II、III",
            "answer": "D",
            "explain": "市现率模型用来计算的现金流指标通常是扣除利息、税款、折旧和摊销之前的收益（EBITDA）。"
        },
        {
            "title": "相对估值法常见的估值比率包括（　　）。",
            "date": "202306",
            "questions": "I．市盈率<br>II．市净率<br>III．贴现率<br>IV．企业价值倍数",
            "question": "A．I、II、IV\nB．I、II\nC．I、II、III\nD．I、II、III、IV",
            "answer": "A",
            "explain": "相对估值包括：市盈率、市净率、市现率、市销率、企业价值倍数（EV/EBITDA）。"
        }, {
            "title": "通过发行债券筹集资金，并在债券到期时按时归还本金并支付约定的利息的是（　　）。",
            "date": "2021",
            "question": "A．债券承销商\nB．债券持有人\nC．债券市场\nD．债券发行人",
            "answer": "D",
            "explain": "债券发行人通过发行债券筹集的资金一般都有固定期限，债券到期时债务人必须按时归还本金并支付约定的利息。"
        },
        {
            "title": "关于债券的发行主体，以下表述正确的是（　　）。",
            "date": "2021",
            "questions": "I．国债是财政部代表中央政府发行的<br>II．国开债属于商业银行债券<br>III．地方政府债由中央政府负责偿还<br>IV．特种金融债券的发行必须经中国人民银行批准",
            "question": "A．I、III、IV\nB．II、III、IV\nC．I、IV\nD．I、II、IV",
            "answer": "C",
            "explain": "国开债（国家开发银行发行的债券）属于政策性金融债，故II错误；地方政府债券包括由中央政府代理发行和地方政府自主发行，均由地方政府负责偿还，故III错误。"
        },
        {
            "title": "下列关于零息债券的说法中，正确的是（　　）。",
            "date": "202306",
            "question": "A．溢价方式发行，到期按债券面值偿还本金\nB．贴现方式发行，到期按票面利率偿还本金和利息\nC．贴现方式发行，到期按债券面值偿还本金和利息\nD．溢价方式发行，到期按票面利率偿还本金和利息",
            "answer": "C",
            "explain": "零息债券和固定利率债券一样有一定的偿还期，但在期间不支付利息，而在到期日一次性支付利息和本金，一般其值为债券面值。因此，零息债券以低于面值的价格发行，到期日支付的面值和发行时价格的差额即为投资者的收益。"
        },
        {
            "title": "某浮动利率债券在支付期期初的基准率为3%，固定利差为50个基点。该浮动利率债券在支付期期初的浮动利率为（　　）。",
            "date": "2021",
            "question": "A．8%\nB．3.50%\nC．3.05%\nD．2.50%",
            "answer": "B",
            "explain": "浮动利率=基准利率+利差，利差用基点表示，1个基点等于0.01%（50个基点=0.01%×50=0.5%），因此，期初支付的浮动利率=3%+0.5%=3.5%，故选B。"
        },
        {
            "title": "关于息票债券和贴现债券，以下表述正确的是（　　）。",
            "date": "202302",
            "question": "A．贴现债券是指在发行时不规定利率、券面不附息票，折价发行的债券\nB．息票债券和贴现债券是按照计息方式分类的两种常见债券类型\nC．与息票债券和贴现债券同属一种分类方法下债券类型的还有金融债券\nD．息票债券一般来说属于短期债券",
            "answer": "A",
            "explain": "按付息方式分类，债券可分为息票债券和贴现债券，故BC错误；息票债券：指债券发行时规定，在债券存续期内，在约定的时间以约定的利率按期向债券持有人支付利息的中、长期债券。债券的持有人于息票到期日，凭债券附带的息票领取最后一期的利息并同时领取债券的本金，故D错误；而贴现债是指无息票债券或零息债券，这种债券在发行时不规定利率，券面也不附息票，发行人以低于债券面额的价格出售债券，即折价发行，债券到期时发行人按债券面额兑付，故A正确。"
        },
        {
            "title": "保证物为发行人持有的债权或股权而非实物资产的债权是（　　）。",
            "date": "202405",
            "question": "A．担保债券\nB．质押债券\nC．无保证证券\nD．抵押债券",
            "answer": "B",
            "explain": "担保债券是由另一实体提供保证发行的债券，A错误；质押债券的保证物是债券发行者持有的债权或股权，而非真实资产，B正确；抵押债券的保证物是土地、房屋、设备等不动产，D错误。"
        },
        {
            "title": "目前我国的资信评级机构大约有50家，其业务范围不包括（　　）。",
            "date": "2021",
            "question": "A．企业债券评级\nB．基金产品评级\nC．证券公司评级\nD．贷款项目评级",
            "answer": "B",
            "explain": "目前我国的资信评级机构大约有50家，其业务范围包括金融机构资信评级、贷款项目评级、企业资信评级、企业债券及短期融资债券资信等级评级、保险公司及证券公司等级评级等。不包括基金产品评级。"
        },
        {
            "title": "下列属于我国债券市场的场外交易场所的是（　　）。",
            "question": "A．银行间市场\nB．深圳证券交易所\nC．融资融券市场\nD．上海证券交易所",
            "answer": "A",
            "explain": "交易所市场为场内市场。融资融券交易在交易所进行，也属于场内交易。银行间债券市场是场外市场。"
        },
        {
            "title": "假设某附息的固定利率债券的起息日为2009年6月6日，债券面值100元，每半年支付一次利息。2019年6月6日，该债券的投资者可就每单位债券收到本金和利息共计102.25元，则该债券的期限为（　　）年，票面利率为（　　）。",
            "date": "202302",
            "question": "A．9；4.5%\nB．10；4.5%\nC．10；2.25%\nD．9；2.25%",
            "answer": "B",
            "explain": "每半年支付一次利息，2019年6月6日，该债券的投资者可就每单位债券收到本金和利息共计102.25元，说明2019年6月6日收到的利息为2.25元，一年可收到4.5元利息，则票面利率为4.5%。2009年6月6日-2019年6月6日总共为10年。"
        },
        {
            "title": "某三年期零息债券面额为1,000元，三年期市场利率为5%，那么该债券目前的市场价格为（　　）。",
            "question": "A．878元\nB．870元\nC．872元\nD．864元",
            "answer": "D",
            "explain": "该三年期零息债券的市场价格为1,000/(1+5%)^3≈864元。"
        },
        {
            "title": "某永续债每年付息一次，每次5元，如市场利率为5%，则该债券的内在价值为（　　）元。",
            "date": "20201128",
            "question": "A．105\nB．100\nC．110\nD．95",
            "answer": "B",
            "explain": "永续债券，V=C/R=5/5%=100。"
        }, {
            "title": "债券市场价格越（　　）债券值，债券期限越（　　），即当期收益率越接近到期收益率。",
            "date": "202306",
            "question": "A．接近；长\nB．偏离；长\nC．偏离；短\nD．接近；短",
            "answer": "A",
            "explain": "债券市场价格越接近债券面值，期限越长，则其当期收益率就越接近到期收益率。"
        },
        {
            "title": "甲、乙、丙三个债券的面额均为100元，已知下列信息，哪个债券的到期收益率最低？（　　）",
            "date": "20201128",
            "questions": "I．债券甲的市场价格为101.9元，票面利率为5%，到期时间为2年<br>II．债券乙的市场价格为100.0元，票面利率为6%，到期时间为2年<br>III．债券丙的市场价格为97.3元，票面利率为5%，到期时间为3年",
            "question": "A．乙债券\nB．信息不足，无法判断\nC．甲债券\nD．丙债券",
            "answer": "C",
            "explain": "【正规方法计算】\n债券甲：101.9=5/（1+x）+5/（1+x）²+100/（1+x）²\n债券乙：100=6/（1+x）+6/（1+x）²+100 / （1+x）²\n债券丙：97.3=5/（1+x）+5/（1+x）²+5/（1+x）³+100/（1+x）³<br>【用直观的方法判断，题目说的是收益率最低】\n债券甲是溢价，说明是高于票面100发行的，票面利率要低于5%；债券乙是平价，说明是正常价格和利率；债券丙是折价，说明是低于票面100发行的，票面利率比5%的要高。"
        },
        {
            "title": "关于收益率曲线的描述，以下说法中错误的是（　　）。",
            "question": "A．收益率曲线大多是向下倾斜的，偶尔也会水平状或向上倾斜\nB．当收益率曲线向下倾斜时，长期利率低于短期利率\nC．当收益率曲线水平时，长期利率等于短期利率\nD．当收益率曲线向上倾斜时，长期利率高于短期利率",
            "answer": "A",
            "explain": "通常情况下，投资者对期限较长的债券会要求较高的风险溢价，造成长期债券的收益率高于同类短期债券的收益率。上升收益率曲线是最常见的形态。"
        },
        {
            "title": "当期限相对较短的债券利率与期限呈正向关系，期限相对较长的债券利率与期限呈反向关系，收益率曲线呈（　　）形态。",
            "date": "20201031",
            "question": "A．拱形\nB．水平\nC．反转\nD．上升",
            "answer": "A",
            "explain": "拱形收益率曲线，其期限结构特征是，期限相对较短的债券，利率与期限成正向关系，而期限相对较长的债券，利率与期限呈反向关系。"
        },
        {
            "title": "关于信用利差，以下表述正确的是（　　）。",
            "date": "202405、202302",
            "questions": "I．信用利差的变化是市场风险偏好的变化<br>II．信用利差可作为预测经济周期活动的指标<br>III．信用利差的变化一般发生在经济周期发生转变后",
            "question": "A．I、III\nB．I、II\nC．II、III\nD．I",
            "answer": "B",
            "explain": "I、II正确、Ⅲ错误：信用利差的变化本质上是市场风险偏好的变化，受经济预期影响。从实际数据看，信用利差的变化一般发生在经济周期发生转换前，因此，【信用利差可以作为预测经济周期活动的指标】。"
        },
        {
            "title": "两种债券存在信用利差，主要是因为它们的（　　）。",
            "date": "202306",
            "questions": "I．到期期限<br>II．信用评级<br>III．票面利率<br>IV．违约风险",
            "question": "A．I、II、III\nB．I、II\nC．II、IV\nD．II、III",
            "answer": "C",
            "explain": "信用利差是指除了【信用评级】不同外， 其余条件全部相同（包括但不于期、 嵌入条款等）的两种债券收益率的差额。 一般而言， 投资者会要求更高的收益来补偿较高的【违约风险】， 即违约风险越高， 投资收益率也应该越高。综上，该选C。"
        },
        {
            "title": "关于免疫策略，以下表述正确的是（　　）。",
            "date": "202302",
            "question": "A．水平配比策略是价格免疫策略中的一种策略\nB．常用的免疫策略包括价格免疫、利率免疫\nC．在尽量减免到期收益率变化所产生的负效应的同时，尽可能从利率变动中获取收益\nD．在久期等于持有期的基础上，选择凸性最低的债券",
            "answer": "C",
            "explain": "A错误：水平配比策略属于所得免疫。\nB错误：常用的免疫策略主要包括：所得免疫、价格免疫和或有免疫。\nC正确：选择免疫策略，就是在尽量减免到期收益率变化所产生负效应的同时，还尽可能从利率变动中获取收益。\nD错误：久期等于持有期的债券，选择凸性最高的那种债券。"
        },
        {
            "title": "某债券的理论上的市场价格上升了8%，其麦考利修正久期为2年，则其理论上的市场利率变动为（　　）。",
            "question": "A．4%\nB．-4%\nC．-16%\nD．16%",
            "answer": "B",
            "explain": "根据久期的定义，债券价格的变化约等于久期乘以市场利率的变化率，方向相反，市场利率=-(债券价格变化/久期)=-(8%/2)=-4%。"
        },
        {
            "title": "货币市场工具的特点包括（　　）。",
            "date": "2021",
            "question": "A．存在较高风险\nB．股转系统交易为主\nC．本金安全性低\nD．机构投资者参与为主",
            "answer": "D",
            "explain": "货币市场主要由机构参与者参与，本金安全性相对较高、风险较低。"
        },
        {
            "title": "质押式回购期间发生质押券的派息，利息归（　　）。",
            "date": "202306",
            "question": "A．融券方\nB．正回购方\nC．逆回购方\nD．双方协商",
            "answer": "B",
            "explain": "【质押式回购期间】在回购期内，资金融入方出质的债券，回购双方均不得动用。质押冻结期间债券的利息归出质方（正回购方）所有。<br>【买断式回购】质押冻结期间债券的利息归债主（逆回购方）所有。"
        },
        {
            "title": "关于衍生工具的特点，以下表述错误的是（　　）。",
            "date": "202306、202302",
            "question": "A．通过衍生工具能够实现小资金撬动大资金\nB．衍生工具可能会因为缺乏交易对手而不能平仓或变现\nC．衍生工具涉及基础资产的跨期转移\nD．衍生资产的价格和合约标的资产价格没有联动性",
            "answer": "D",
            "explain": "D错误：联动性指衍生工具的价值与合约标的资产价值紧密相关，衍生资产价格与标的资产的价格具有联动性】。例如，我国股指期货沪深300指数合约与沪深300股票指数价格走势密切相关，内在价值存在高度关联性。"
        },
        {
            "title": "下列关于衍生工具的说法，错误的是（　　）。",
            "question": "A．按产品形态可以分为独立衍生工具、嵌入式衍生工具\nB．独立衍生工具指期权合约、期货合约或者互换合约\nC．按合约特点可以分为远期合约、期货合约、期权合约、互换合约和结构化金融衍生工具\nD．远期合约、期货合约、互换合约、结构化金融衍生工具常被称为基础性衍生模块",
            "answer": "D",
            "explain": "基础性衍生模块不包括结构化金融衍生工具。"
        },
        {
            "title": "关于远期合约，以下表述错误的是（　　）。",
            "date": "20201128",
            "question": "A．远期合约通常在到期前对冲抵消，而不必在到期时进行实物交割\nB．远期合约双方在未来均负有义务\nC．远期合约经双方谈判商定，交易成本较高\nD．远期合约双方均面临对方违约的风险",
            "answer": "A",
            "explain": "期货合约通常在到期前对冲抵消，而不必在到期时进行实物交割，而远期在到期时需要进行交割。"
        },
        {
            "title": "期货合约具有标准化的特征，在固定场所交易，是（　　）的替代物。",
            "date": "2021",
            "question": "A．债券\nB．远期合约\nC．股票\nD．抵押品",
            "answer": "B",
            "explain": "期货合约随着价格变化而修改合约，它是远期合约的替代物。"
        },
        {
            "title": "某投资者A预测股票市场将下跌，于是卖出当月沪深300股指期货合约，准备指数下跌后买入期指获利。A的操作属于（　　）。",
            "question": "A．空头投机\nB．多头投机\nC．多头套保\nD．空头套保",
            "answer": "A",
            "explain": "在交易中，投机者预测未来价格波动方向并确定交易头寸的方向。若投机者预测价格下跌卖出期货合约，持有空头头寸，称为空头投机者。"
        },
        {
            "title": "期货市场风险管理的功能是通过（　　）实现的。",
            "date": "2021",
            "question": "A．卖空\nB．套期保值\nC．买空\nD．建仓",
            "answer": "B",
            "explain": "期货市场的最基本的功能就是风险管理，具体表现为利用商品期货管理价格风险，利用外汇期货管理汇率风险，利用利率期货管理利率风险，以及利用股指期货管理股票市场系统性风险。"
        },
        {
            "title": "关于期货合约，以下表述错误的是（　　）。",
            "date": "202306",
            "question": "A．盯市制度对保证期货合约的履约非常重要\nB．期货合约是非标准化合约\nC．投机者是期货市场的重要组成部分\nD．金融期货合约的交割大多采用现金结算",
            "answer": "B",
            "explain": "A正确：盯市对于保证期货合约的履行至关重要。\nB错误：期货合约是【标准化合约】。\nC正确：投机者是期货市场的重要组成部分。\nD正确：期货合约绝大多数通过对冲相抵消，通常用现金结算，极少实物交割。"
        },
        {
            "title": "关于期货合约和远期合约的比较，下列叙述不正确的是（　　）。",
            "date": "202306",
            "question": "A．期货合约在交易所交易，远期合约通常在场外交易\nB．期货合约实物交割比例非常低，远期合约实物交割比例非常高\nC．期货合约和远期合约都有杠杆效应\nD．期货合约是标准化合约，远期合约是非标准化合约",
            "answer": "C",
            "explain": "C错误：期货合约通常用保证金交易，因此有明显的杠杆，而远期合约通常没有杠杆效应。"
        },
        {
            "title": "关于期权合约，以下表述错误的是（　　）。",
            "date": "2021",
            "question": "A．期权费是期权买方为获取期权的合约所赋予的权利而向期权卖方支付的费用\nB．期权的执行价格是期权卖方在行使权利时所实际执行的价格\nC．期权的买方同时也是期权的多头\nD．期权的卖方同时也是期权的空头",
            "answer": "B",
            "explain": "期权的执行价格是期权买方（不是卖方）在行使权利时所实际执行的价格。"
        },
        {
            "title": "关于期权，以下表述错误的是（　　）。",
            "date": "202302",
            "question": "A．期权买方在未来买卖标的物的价格是事先规定好的\nB．期权的买方要付给卖方一定数量的权利金\nC．期权合约中的标的资产，可以是实物商品、金融资产、利率、汇率或各种综合价格指数等\nD．期权买方到期必须履约，不履约需缴纳罚金",
            "answer": "D",
            "explain": "AB正确：期权合约，又称作选择权合约，是指赋予期权买方在规定期内按双方约定的价格买入或卖出一定数量的某种金融资产的权利的合同。约定的价格被称作执行价格或协议价格。 C正确：标的资产即期权合约中约定交易的资产，可以是实物商品、金融资产、利率、 汇率或各种综合价格指数等。 D错误：期权的买方买入期权后，即拥有了权力，期权的买方既可以选择行权，也可以放弃行权】。"
        },
        {
            "title": "若其他条件不变，标的资产价格的波动率越大，看涨期权价值（　　），看跌期权价值（　　）。",
            "question": "A．越高；越高\nB．越低；越低\nC．越低；越高\nD．越高；越低",
            "answer": "A",
            "explain": "波动率越大，看涨期权和看跌期权价值都会越高。"
        },
        {
            "title": "利率互换的形式有（　　）。",
            "date": "202306",
            "question": "A．息票互换和币种互换\nB．息票互换和基础互换\nC．基础互换和交叉互换\nD．币种互换和交叉互换",
            "answer": "B",
            "explain": "利率互换有两种形式：1.息票互换，即固定利率对浮动利率的互换；2.基础互换，即双方以不同参照利率互换利息支付，如美国优惠利率对LIBOR。"
        }, {
            "title": "关于股票收益互换，以下表述错误的是（　　）。",
            "date": "202405、202306",
            "question": "A．投资者无法通过股票收益互换进行风险管理\nB．股票收益互换的模式包括固定利率和股票收益互换\nC．股票收益互换中，支付的金额与特定股票、指数等权益类标的表现挂钩\nD．通常进行净额交收，不发生本金交换",
            "answer": "A",
            "explain": "A错误：股票收益互换是投资者进行投资理财和风险管理的工具。投资者可以通过股票收益互换，实现策略投资、杠杆交易、股权融资、市值管理和创建结构产品的目的。证券公司在与投资者订立股票收益互换交易的同时，会进行风险对冲，将自身风险暴露控制在较低水平。风险对冲后，证券公司最终只赚取类似佣金或利息收入的中间价差。 B正确：投资者和证券公司之间的股票收益互换有三种模式：固定利率和股票收益的互换，股票收益和固定利率的互换，股票收益和股票收益的互换。前两种形式更为常见。 CD正确：股票收益互换中，交易一方或双方支付的金额与特定股票、指数等权益类标的证券的表现挂钩。原则上，双方按照收益轧差后的净额进行支付，不发生本金交换。"
        },
        {
            "title": "另类投资的主要类型包括（　　）。",
            "date": "2021",
            "question": "A．股票基金、混合基金、债券基金、货币基金\nB．权益投资、固定收益投资、衍生工具\nC．另类资产、另类投资策略、私募股权、对冲基金\nD．黄金投资、碳排放权投资、艺术品和收藏品投资",
            "answer": "C",
            "explain": "另类投资的主要类型包括另类资产、另类投资策略、私募股权和对冲基金。"
        },
        {
            "title": "机构投资者将另类投资产品纳入其传统投资组合的主要原因是（　　）。",
            "date": "202306",
            "question": "A．另类投资产品收益的标准差较小，能分散投资组合的风险\nB．纳入另类投资产品可以很大程度上降低投资组合的夏普比率\nC．纳入另类投资产品可以提高投资回报和分散投资风险\nD．另类投资产品具有强监管，信息透明度高的特性，从而较为安全",
            "answer": "C",
            "explain": "C正确：投资者将另类投资产品纳入投资组合当中，主要目的是通过投资组合提高投资回报和分散风险】。"
        },
        {
            "title": "下列选项中，属于另类投资的局“性”的是（　　）。",
            "question": "A．与传统资产相关度低\nB．信息透明度低\nC．监管严格\nD．收益率低",
            "answer": "B",
            "explain": "另类投资的局“性”有：缺乏监管和信息透明度、流动性较差、杠杆率偏高、估值难度大。"
        },
        {
            "title": "下列哪一类私募股权投资的战略通常是向初创型企业提供资金？（　　）。",
            "date": "2021、20201128",
            "question": "A．风险投资\nB．并购投资\nC．成长权益\nD．危机投资",
            "answer": "A",
            "explain": "风险投资一般采用股权形式，将资金投入提供具有创新性的专门产品或服务的初创型公司，从事风险投资的人员或机构被称为“天使投资者”。"
        },
        {
            "title": "关于公司型私募股权基金，以下表述错误的是（　　）。",
            "question": "A．公司型私募股权基金的投资者一般享有作为股东的一切权利\nB．公司型私募股权基金的基金管理人会受到股东的严格监督管理\nC．公司型私募股权基金通常具有较为完整的公司结构\nD．公司型私募股权基金的投资者需要承担无限责任",
            "answer": "D",
            "explain": "公司型私募股权基金的投资者以出资额为“承担有限责任”。"
        },
        {
            "title": "私募股权基金完成投资项目后主要采取的退出渠道包括（　　）。",
            "questions": "I．首次公开发行<br>II．破产清算<br>III．管理层回购<br>IV．二次出售",
            "question": "A．I、III、IV\nB．I、II、III\nC．I、II、IV\nD．I、II、III、IV",
            "answer": "D",
            "explain": "私募股权基金完成投资项目后主要采取的退出渠道包括首次公开发行、借壳上市、管理层回购、二次出售、破产清算等。"
        },
        {
            "title": "以时间为横轴、以收益率为纵轴，反映私募股权基金投资收益率与时间关系的曲线叫做（　　）。",
            "question": "A．B曲线\nB．A曲线\nC．K曲线\nD．J曲线",
            "answer": "D",
            "explain": "投资者在考察其所投资的私募股权基金收益状况描绘一条曲线，以时间为横轴、以收益率为纵轴，轨迹大致和字母J相似，因此被称为J曲线。"
        },
        {
            "title": "不动产投资的特点包括（　　）。",
            "questions": "I．异质性<br>II．不可分性<br>III．高流动性<br>IV．低流动性",
            "question": "A．I、II\nB．II、III\nC．I、II、III\nD．I、II、IV",
            "answer": "D",
            "explain": "不动产投资具有：异质性、不可分性、低流动性。"
        }, {
            "title": "关于房地产有限合伙，以下表述错误的是（　　）。",
            "date": "202306",
            "question": "A．有限合伙人的投资资金可以在承诺期限截止之前投资项目中退出\nB．普通合伙人对外代表合伙企业，管理和经营项目\nC．有限合伙人仅以出资份额为限对投资项目承担有限责任\nD．由普通合伙人和有限合伙人组成",
            "answer": "A",
            "explain": "D正确：房地产有合伙由有合伙人和普通合伙人组成。\nBC正确：房地产有合伙人将资金提供给普通合伙人，有合伙人仅以出资份额为对投资项目承担有限责任，并不直接参与管理和经营项目；普通合伙人通常是房地产开发公司，依赖其具备的专业能力和丰富经验将资金投资于房地产项目当中，之后管理并经营这些项目。\nA错误：房地产有合伙偏好资金的非流动性， 一旦房地产有合伙将资金托付给合伙企业， 可能在承诺期截止之前【很难或者不可能】从投资项目中退出。"
        },
        {
            "title": "关于不动产投资的含义和特点，以下表述错误的是（　　）。",
            "date": "202302",
            "question": "A．直接的不动产投资流动性较差，通常表现为若要快速转售，投资者往往要承担较大折价损失\nB．直接的不动产投资金额大且难以拆分，这意味着该项投资可能会占据到一个投资组合的很大比例\nC．不动产投资是指投资者直接出资购买商业房地产，用于出租获取租金收益或等待增值之后出售获取增值收益\nD．不动产投资具有异质性，这使得不动产估值具有一定的难度",
            "answer": "C",
            "explain": "A正确：直接的不动产投资流动性较差，产权交易时间长、费用高。 若要快速转售，往往要承担较大的折价损失。\nB正确：直接的不动产投资金额大，且不容易拆分以卖给多个投资者。这意味着一项投资就可能占据投资组合的很大比例。\nC错误：对大多数个体投资者而言，不动产投资意味着购买自己的居住用房地产，这也是这些投资者所持有的资产净值当中的重要部分。住宅型建筑物、公寓和其他住宅型房地产都是许多个体投资者的财务计划当中最基础的部分。\nD正确：不动产投资具有异质性给房地产估值带来了困难。"
        },
        {
            "title": "以下选项中，属于基础原材料类大宗商品的是（　　）。",
            "date": "202306",
            "questions": "I．钢铁、铜、铝<br>II．橡胶、黄金、白银<br>III．玉米、大豆、棕榈油<br>IV．铅、锌、铁矿石",
            "question": "A．II、IV\nB．II、III\nC．I、IV\nD．I、II",
            "answer": "C",
            "explain": "【基础原材料类】钢铁、铜、铝、铅、锌、镍、钨、橡胶、铁矿石等；【能源类】原油、汽油、天然气、动力煤、甲醇等；【贵金属类】黄金、白银、铂金等；【农产品类】玉米、大豆、小麦、稻谷、咖啡、棉花、鸡蛋、棕榈油、菜油、白砂糖等。"
        },
        {
            "title": "关于投资组合管理的基本流程，以下表述错误的是（　　）。",
            "date": "202405",
            "question": "A．投资规划的首要任务就是建立战略资产配置\nB．投资管理过程是一个动态反馈的循环过程\nC．投资管理的目标是使投资者在获得一定收益水平的同时承担最低的风险\nD．投资管理的目标是在投资者可接受的风险水平内使其获得最大的收益",
            "answer": "A",
            "explain": "A错误：投资规划的首要任务就是了解客户需求，确认并量化投资者的投资目标和投资制。\nB正确：投资管理过程定义为一个动态反馈的循环过程。\nCD正确：投资组合管理的目标是实现投资收益的最大化，就是使投资者在获得一定收益水平的同时承担最低的风险，或在投资者可接受的风险水平内使其获得最大的收益。"
        },
        {
            "title": "个人投资者的投资需求会受到多方面因素的影响，在不考虑其他因素的情况下，下列对各影响因素的表述错误的是（　　）。",
            "date": "202306",
            "question": "A．拥有的财富越多，风险承受能力越强\nB．拥有稳定增长工资收入的，风险承受能力越强\nC．随着年龄的增长，风险承受能力递增\nD．投资经验越丰富，风险承受意愿越强",
            "answer": "C",
            "explain": "一般来说，随着年龄的增长，风险承受能力逐渐递减。"
        },
        {
            "title": "如果按照个人投资者所处生命周期的不同阶段来选择基金产品类型，一般来说，适合老年人的投资原则是（　　）。",
            "question": "A．坚持稳健原则，分散风险，选择收益与风险均衡化的产品\nB．以低风险为核心，不宜过多配置股票型基金\nC．以保值增值为目标，选择中高风险的产品进行组合投资\nD．首选高风险、投资周期长的产品",
            "answer": "B",
            "explain": "老年人风险承受能力低，以低风险为核心，不宜过多配置股票型基金，以稳健、安全、保值最为重要。"
        }, {
            "title": "关于机构投资者的常见特征，以下表述错误的是（　　）。",
            "date": "202302",
            "question": "A．投资行为规范\nB．风险承受能力比个人投资者更低\nC．投资管理专业\nD．资金实力雄厚，投资规模相对较大",
            "answer": "B",
            "explain": "相比个人投资者，机构投资者通常具有以下特征：\n1、资金实力雄厚，投资规模相对较大，故D正确；\n2、具有比个人投资者更高的风险承受能力，故B错误；\n3、投资管理专业，故C正确；\n4、投资行为规范，故A正确。"
        },
        {
            "title": "关于基金的机构投资者，以下说法错误的是（　　）。",
            "date": "2021",
            "question": "A．社会保障基金中包含养老保险资金，投资期较长，通常投资于风险较高的资产\nB．财险公司收取的保费投资期较短，通常投资于低风险资产\nC．寿险公司收取的保费投资期较长，通常可以投资于风险较高的资产\nD．企业年金基金可投资于货币市场工具、债券、股票等，但有严格投资比例限制",
            "answer": "A",
            "explain": "社会保障基金投资的基本原则为：在保证基金安全性、流动性的前提下实现基金资产的增值。故为了基金的安全，不能投资于风险较高的资产。"
        },
        {
            "title": "关于投资者风险容忍度，以下表述错误的是（　　）。",
            "date": "202405",
            "question": "A．其他条件相同时，家庭资产越多，风险承受能力越强\nB．其他条件相同时，投资期越长，风险承受能力越强\nC．其他条件相同时，风险厌恶程度越高，风险承受能力越强\nD．其他条件相同时，家庭收入越高，风险承受能力越强",
            "answer": "C",
            "explain": "其他条件相同时，风险厌恶程度越高，风险承受能力越弱。"
        },
        {
            "title": "关于投资者承担风险的容忍度，以下表述正确的有（　　）。",
            "date": "202302",
            "questions": "I．投资者的风险容忍度取决于其承担风险的能力和受教育程度两方面<br>II．相比投资期限较短的投资者，投资期限较长的投资者具有更高的风险承受能力<br>III．通常认为承担风险的意愿对机构投资者更为重要<br>IV．保险公司等金融机构在承担投资风险时往往受到监管约束，对投资风险承担加以限制",
            "question": "A．I、II\nB．II、III\nC．II、IV\nD．I、IV",
            "answer": "C",
            "explain": "第I项错误：投资者的风险容忍度取决于其承担风险的能力和意愿两个方面。\n第II项正确：其他条件相同的条件下，相比投资期较短的投资者而言，投资期较长的投资者具有更高的风险承受能力。\n第III项错误：通常认为承担风险的意愿对个人投资者更为重要。\n第IV项正确：保险公司等金融机构在承担投资风险时往往还受到监管约束。综上，该题选C。"
        },
        {
            "title": "关于资产流动性和资产配置，以下说法正确的是（　　）。",
            "question": "A．一般而言，流动性更强的资产，其预期收益率更高\nB．若投资者有随时变现的需求，则不适宜将资金投资于有封闭期的基金\nC．流动性是指投资者短期内将投资资产变现的容易程度，不考虑变现成本\nD．若没有预期的变现需求，投资者应将全部资金投资于流动性低的资产以获取高收益",
            "answer": "B",
            "explain": "一般而言，流动性更强的资产，其预期收益率越低；流动性是指投资者短期内将投资资产变现的容易程度，考虑变现成本；投资者将资金投资于流动性不同的资产，从而分散风险，平衡收益。"
        },
        {
            "title": "关于投资政策说明书，以下表述错误的是（　　）。",
            "question": "A．制定投资政策说明书的关键环节之一是对投资者需求进行分析\nB．投资政策说明书在制定之后不能一成不变，也不能想变就变，只能每年定期地进行更新\nC．制定投资政策说明书的好处之一是有助于合理评估投资管理人的投资业绩\nD．投资政策说明书能够帮助投资者制定切合实际的投资目标",
            "answer": "B",
            "explain": "投资政策说明书在制定之后根据投资者需求变化需要定期、不定期重新审核与更新。"
        },
        {
            "title": "关于基金投资运作过程中的集中交易制度，以下理解正确的是（　　）。",
            "date": "202306",
            "question": "A．基金的投资决策职能与交易执行职能分别是由基金经理与基金交易部门承担的\nB．基金经理直接向交易员下达投资指令\nC．基金经理直接进行交易\nD．交易指令应包含确切的交易价格，交易员严格按照该价格水平进行证券交易",
            "answer": "A",
            "explain": "A正确：为提高交易效率和有效控制基金管理中交易执行的风险，基金采取集中交易制度，即【基金的投资决策与交易执行职能分别由基金经理与基金交易部门承担】。 \nBC错误：基金经理不得直接向交易员下达投资指令或者直接进行交易。\nD错误：交易员接收到指令后有权根据自身对市场的判断选择合适时机完成交易。"
        },
        {
            "title": "某灵活配置型混合基金，其投资范围内约定股票的投资比例为0-95%，该基金有两位基金经理，一位负责股票的投资，一位负责债券的投资，在实际投资过程中，以下表述错误的是（　　）。",
            "date": "202306",
            "question": "A．基金经理需要进行大类资产分析，从而决定在股票、债券、现金等大类资产上的配置比例\nB．该基金的风险水平高于债券型基金，低于股票型基金\nC．该基金的优势是根据行情进行大类资产调整，受股票仓位的约束较小\nD．两位基金经理的投资工作是隔离的，分别单独做投资决定",
            "answer": "D",
            "explain": "D错误：在基金管理中，两位基金经理的合作模式通常不是各自独立进行决策，而是存在一定程度的合作与协调。"
        },
        {
            "title": "在基金公司投资交易流程中，交易系统或相关负责人将违规的指令拦截，然后反馈给（　　）。",
            "date": "20201031",
            "question": "A．交易员\nB．投资总监\nC．研究员\nD．基金经理",
            "answer": "D",
            "explain": "交易系统或相关负责人审核投资指令（价格、数量）的合法合规性，违规指令将拦截并反馈给基金经理。"
        },
        {
            "title": "投资组合理论的基本假设是（　　）。",
            "date": "202306",
            "question": "A．投资者是理性的\nB．投资者获得的信息都是公开的\nC．投资者是追求高收益的\nD．投资者是风险厌恶的",
            "answer": "D",
            "explain": "马科维茨投资组合理论的基本假设是投资者是厌恶风险的。如果在两个具有相同预期收益率的证券之间进行选择，投资者会选择风险较小的。要让投资者承担更高的风险，必须有更高的预期收益来补偿。"
        }, {
            "title": "关于方差和标准差，以下表述错误的是（　　）。",
            "date": "202405",
            "question": "A．方差可以表示样本数据的离散程度\nB．计算样本方差要用到样本均值\nC．标准差可以表示样本数据偏离均值的程度\nD．方差的平方是标准差",
            "answer": "D",
            "explain": "方差和标准差是从历史数据或者模型模拟得出的，方差值是标准差的平方，方差或标准差越大，表明这组数据离散程度越高方差和标准差是对已有数据的离散程度的描述，没有预测功能。"
        },
        {
            "title": "某股票类资产A，下一年度的期望收益率为13%。下一年度股市为牛市的概率为35%，牛市中股票类资产A收益率为40%；股市为熊市的概率为25%，熊市中股票类资产A的收益率为-20%；股市为震荡市的概率为40%，震荡市中股票类资产A收益率为10%；则该类资产A的收益率方差为（　　）。",
            "date": "2021",
            "question": "A．1.02\nB．0.13\nC．0.23\nD．0.053",
            "answer": "D",
            "explain": "方差计算公式为：σ²＝[r1－E（r）]²×p1＋[r2－E（r）]²×p2＋……＋[rn－E（r）]²×pn＝（40%－ 13%）²×35%＋（-20%－13%）² ×25%＋（10%－13%）²×40%≈0.053。"
        },
        {
            "title": "设有两种证券A和B，某投资组合将资金中的30%购买了证券A，70%的资金购买了证券B。到期时，证券A的收益率为5%，证券B的收益率为10%，则该证券组合的收益率为（　　）。",
            "date": "20201128",
            "question": "A．7.5%\nB．8%\nC．8.5%\nD．9",
            "answer": "C",
            "explain": "证券组合收益率计算公式为：收益率 = 证券A收益率 * 证券A投资比例 + 证券B收益率 * 证券B投资比例。根据题目条件计算得出证券组合收益率为5%*30%+10%*70%=8.5%。"
        },
        {
            "title": "由于存在一系列同时影响多个资产收益的因素，大多数资产的收益之间会存在（　　）。",
            "question": "A．至斥性\nB．相关性\nC．互补性\nD．一致性",
            "answer": "B",
            "explain": "由于存在一系列同时影响多个资产收益的因素，大多数资产的收益之间都会存在一定的相关性。"
        },
        {
            "title": "如果a与b证券之间的相关系数绝对值比b与c证券之间的相关系数绝对值大，则证券之间的相关性的强弱关系为（　　）。",
            "date": "202302",
            "question": "A．无法确定\nB．b与c证券之间的相关性更强\nC．a与b证券之间的相关性更强\nD．一致",
            "answer": "C",
            "explain": "相关系数的绝对值大小体现两个证券收益率之间相关性的强弱，如果a与b证券之间的相关系数绝对值比b与c证券之间的相关系数绝对值大，则说明a与b证券之间的相关性更强。"
        },
        {
            "title": "在组合投资理论中，有效投资组合是指（　　）。",
            "question": "A．最小方差前沿右边界上的任意可行组合\nB．最小方差前沿内部任意可行组合\nC．在所有风险相同的投资组合中具有最高预期收益率的组合\nD．最小方差前沿左边界上的任意可行组合",
            "answer": "C",
            "explain": "有效投资组合的特点是同收益时风险最低，同风险时收益最高。"
        },
        {
            "title": "关于均值-方差模型，以下表述错误的是（　　）。",
            "date": "20211128",
            "question": "A．无差异曲线是在期望收益-标准差平面上有相同给定效用的所有点组成的曲线\nB．从全局最小方差组合开始，最小方差前沿的下半部分就称为有效前沿\nC．市场上可投资产形成的所有组合称为可行集\nD．无差异曲线和有效前沿相切的点所代表的投资组合称为最优组合",
            "answer": "B",
            "explain": "从全局最小方差组合开始，最小方差前沿的上半部分就称为有效前沿。"
        },
        {
            "title": "以下不属于资本资产定价模型关于同质期望假定的是（　　）。",
            "date": "20201128",
            "question": "A．所有投资者都具有同样的信息\nB．所有投资者都以方差来度量投资风险\nC．所有投资者对各种资产的预期收益率，风险及资产间的相关性都具有同样判断\nD．所有投资者对资产的收益率服从的概率分布具有一致的看法",
            "answer": "B",
            "explain": "所有投资者的期望相同，即任何投资者认为同一个股票有相同的风险/收益分布。所有投资者都具有同样的信息，他们对各种资产的预期收益率、风险及资产间的相关性都具有同样的判断，即对所有资产的收益率所服从的概率分布具有一致的看法。这一假定也被称为同质期望假定或同质信念假定。"
        },
        {
            "title": "根据风险-收益分析框架，两位具有不同风险厌恶程度的投资者，他们的最优投资组合与资本市场线的关系是（　　）。",
            "date": "202405、202302",
            "question": "A．风险厌恶程度高的投资人，其选择最终会位于资本市场线下方\nB．不管风险厌恶程度高还是低，这两位投资人的选择最终都会落在资本市场线上\nC．不管风险厌恶程度高还是低，这两位投资人的选择最终都会落在有效前沿内部\nD．风险厌恶程度低的投资人，其选择最终会位于资本市场线下方",
            "answer": "B",
            "explain": "引入无风险资产后，资本市场线成为新的有效前沿，所有投资者都会得到同样的有效前沿，所有投资者的选择最终都会落在资本市场线上。"
        },
        {
            "title": "以下属于债券投资系统性风险的是（　　）。",
            "date": "202302",
            "question": "A．债券信用评级被下调\nB．通货膨胀\nC．信用债交易流动性不足\nD．发行方宣布回购债券",
            "answer": "B",
            "explain": "系统风险是指那些影响所有公司的因素引起的风险。例如，战争、经济衰退、通货膨胀、高利率等非预期的变动。"
        },
        {
            "title": "关于系统性风险和非系统性风险，以下表述错误的是（　　）。",
            "date": "2021",
            "question": "A．政策风险属于系统性风险\nB．非系统性风险主要包括由政治因素、宏观经济因素、法律因素等引起的风险\nC．组合化投资可以分散非系统性风险\nD．非系统性风险往往是由某个或者少数特别因素导致的",
            "answer": "B",
            "explain": "系统性风险主要包括由政治因素、宏观经济因素、法律因素等引起的风险，故B错误。"
        },
        {
            "title": "关于贝塔系数和其他系数，以下表述正确的是（　　）。",
            "date": "202405",
            "questions": "I．某资产的贝塔系数越大，意味着该资产收益率与市场组合收益率的协方差越大<br>II．两种金融资产收益率相关系数和协方差符号总是相同<br>III．相关系数为0代表两种金融资产收益率之间无线性相关联<br>IV．除非两种金融资产收益率是完全正相关的，否则分散投资总是能够降低投资组合的风险",
            "question": "A．III、IV\nB．I、II、III、IV\nC．II、IV\nD．II、III、IV",
            "answer": "B",
            "explain": "两种金融资产收益率相关系数和协方差符号总是相同。相关系数为0代表两种金融资产收益率之间无线性相关联。除非两种金融资产收益率是完全正相关的，否则分散投资总是能够降低投资组合的风险。综上，该题选B。"
        }, {
            "title": "某基金与市场收益的相关系数为0.68，基金收益标准差为0.56，市场收益标准差为0.44，该基金贝塔系数为（　　）。",
            "question": "A．1.23\nB．0.87\nC．1\nD．0.55",
            "answer": "B",
            "explain": "贝塔系数β=相关系数×资产收益的标准差÷市场收益的标准差=0.68×0.56÷0.44≈0.87"
        },
        {
            "title": "市场组合预期收益率为10%，10年期国债利率为3%，股票A、B、C、D的贝塔值（A=0.5；B=0.8；C=1.1；D=1.2）。根据CAPM，股票D的期望收益率为（　　）。",
            "question": "A．8.40%\nB．15%\nC．13%\nD．11.40%",
            "answer": "D",
            "explain": "股票D的期望收益率=无风险利率+β×（市场组合预期收益率-无风险利率）=3%+1.2×（10%-3%）=11.4%（备注：国债利率可以作为无风险利率）。"
        },
        {
            "title": "如果证券市场为半强有效市场，则证券价格能够充分反映以下信息中的（　　）。",
            "questions": "I．内部信息<br>II．历史股价<br>III．历史成交量<br>IV．公司分红公告<br>V．股票分拆公告",
            "question": "A．I、IV、V\nB．II、III、IV、V\nC．II、III\nD．I、III、IV",
            "answer": "B",
            "explain": "半强有效证券市场是指证券价格不仅已经反映了历史价格信息，而且反映了当前所有与公司证券有关的公开有效信息，如盈利预测、红利发放、股票分拆、公司并购等各种公告信息。"
        },
        {
            "title": "在半强有效证券市场中，证券价格所反映的信息不包括（　　）。",
            "question": "A．证券的盈利预测、未公开发布的公司重组信息\nB．证券的交易量、红利发放公告\nC．证券的交易量、公司并购公告\nD．证券的盈利预测、公司并购公告",
            "answer": "A",
            "explain": "半强有效证券市场是指证券价格不仅已经反映了【历史价格信息】，而且反映了当前所有与公司证券有关的【公开有效信息】，如盈利预测、红利发放、股票分拆、公司并购等各种公告信息。 A选项：证券的盈利预测属于反映当前与公司证券有关的公开有效信息  ，未公开发布的公司重组信息属于内部信息。\nBCD选项：证券交易量属于历史价格信息、红利发放公告、公司并购公告属于公开信息。\n综上，该题选A。"
        },
        {
            "title": "以下指数中不属于国内股票价格指数的是（　　）。",
            "question": "A．上证180指数\nB．金融时报股价指数\nC．沪深300指数\nD．深证综合股票价格指数",
            "answer": "B",
            "explain": "国内股票价格指数主要包括上证股票价格指数、深证综合股票价格指数、沪深300指数、上证180指数等，ACD正确。\n国际上主要的股票价格指数有道琼斯股价平均指数、标准普尔股价指数、金融时报股价指数、日经指数等。"
        },
        {
            "title": "某投资组合过去3周的收益率分别为3.69%、-0.56%、-1.41%，基准组合的收益率是3.72%、-1.09%、-1.35%，则该组合近三周跟踪偏离度的平均值是（　　）。",
            "question": "A．0.44%\nB．0.27%\nC．0.15%\nD．0.07%",
            "answer": "C",
            "explain": "跟踪偏离度=证券组合的真实收益率-基准组合的收益率。跟踪偏离度平均值={(3.69%-3.72%)+[-0.56%-(-1.09%)]+[-1.41%-(-1.35%)]}/3=0.15%。"
        },
        {
            "title": "关于跟踪误差，以下表述正确的是（　　）。",
            "question": "A．跟踪误差是一个绝对风险指标\nB．跟踪误差计量的前提是清晰的业绩比较基准\nC．主动管理基金的跟踪误差通常比较小\nD．跟踪误差无法衡量投资组合的相对风险是否符合预定的目标",
            "answer": "B",
            "explain": "A错误：波动率是一个绝对风险指标，跟踪误差则是相对于业绩比较基准的相对风险指标。\nB正确：跟踪误差计量的前提是清晰的业绩比较基准。\nC错误：指数基金的跟踪误差通常较低。主动管理基金受到投资目标和风格不同的影响，跟踪误差较大。\nD错误：跟踪误差可以用来衡量投资组合的相对风险是否符合预定的目标或是否在正常范围内。"
        },
        {
            "title": "关于主动管理基金和股票型指数基金，以下表述正确的是（　　）。",
            "question": "A．股票型指数基金投资人收益大幅超越指数的可能性低\nB．股票型指数基金的收益总是低于主动管理基金的收益\nC．股票型指数基金的管理费率高于主动管理基金的管理费率\nD．股票型指数基金的交易费用高于主动管理基金的交易费用",
            "answer": "A",
            "explain": "指数型基金是被动投资基金，力图复制目标指数的业绩，使跟踪误差最小化，收益大幅超越指数的可能性低。"
        }, {
            "title": "关于战略资产配置以及战术资产配置，以下表述正确的是（　　）。",
            "date": "202405",
            "questions": "I．择时被广泛运用于战略资产配置中<br>II．当市场环境发生变化时，战术资产配置将在遵守战略资产配置确定的大类资产比例基础上，对投资组合中各特定资产类别的权重配置进行调整<br>III．战术资产配置是对资产配置状态进行静态调整<br>IV．战术资产配置的周期较短，一般在一年以内",
            "question": "A．II、III\nB．II、IV\nC．I、II\nD．I、IV",
            "answer": "B",
            "explain": "Ⅰ错误：战术资产配置更多地关注市场的短期波动，强调根据市场的变化，运用金融工具，通过择时，调节各大类资产之间的分配比例，来管理短期的投资收益和风险。\nII正确：战术资产配置就是在遵守战略资产配置确定的大类资产比例基础上，根据短期内各特定资产类别的表现，对投资组合中各特定资产类别的权重配置进行调整。 Ⅲ错误：战术资产配置是一种根据对短期资本市场环境及经济条件的预测，积极、主动地对资产配置状态进行动态调整，从而增加投资组合价值的积极战略。 Ⅳ正确：战术资产配置的周期较短，一般在一年以内，如月度、季度。"
        },
        {
            "title": "自上而下股票投资策略在实际应用中，不包括（　　）。",
            "date": "",
            "question": "A．从周期非敏感型行业转换为周期敏感型行业，从而获得板块的差额收益\nB．根据宏观经济决定大类资产配置\nC．运用基本面分析深入研究个股的投资价值\nD．转换价值股和成长股的投资比例，追求风格收益",
            "answer": "C",
            "explain": "自上而下股票投资策咯在实际应用中，包括：通过研究决定经济形势的几个核心变量，決定大类资产配置，B不选；通过积极的风格调整，追求风格收益，转换价值股与成长股投资比例，D不选；可进行积极的板块轮换，获得板块的差额收益，从周期非敏感型行业转换为周期敏感型行业，A不选。"
        },
        {
            "title": "相比于股票投资组合，债券投资组合构建时需考虑的特有因素包括（　　）。",
            "date": "20211128",
            "questions": "I．期限结构<br>II．投资理念<br>III．投资策略<br>IV．组合久期",
            "question": "A．II、III\nB．III、IV\nC．I、IV\nD．I、II",
            "answer": "C",
            "explain": "久期和凸性是债券独有的特征，故I和IV是债券组合区别于股票需要特别考虑的因素。"
        },
        {
            "title": "关于经纪人，以下表述正确的是（　　）。",
            "date": "202405",
            "question": "A．经纪人是报价驱动市场上最重要的角色\nB．经纪人是市场流动的主要提供者\nC．经纪人通过买卖双方的差价赚取主要利润\nD．经纪人在交易中只是执行投资者的指令，本身并未参与到交易之中",
            "answer": "D",
            "explain": "A项错误：在报价驱动市场中，【做市商】是市场流动性的主要提供者和维持者。\nB项错误：经纪人只提供一些信息，撮合双方进行交易。\nD正确：在指令驱动市场中，市场流动性是由投资者的买卖指令提供的，经纪人只是执行这些指令。\nC项错误：【做市商】的利润主要来自于证券买卖差价，经纪人的利润则主要来自于给投资者提供经纪业务的佣金。"
        },
        {
            "title": "关于做市商和经纪人，以下表述正确的是（　　）。",
            "date": "202306、202302",
            "question": "A．二者有时可以共同完成证券交易\nB．报价驱动市场的做市商和指令驱动市场的经纪人都是市场流动性的主要提供者和维持者\nC．二者都直接参与到交易中\nD．二者的利润来源相同",
            "answer": "A",
            "explain": "关于做市商和经纪人的区别：\nC错误：1.两者的市场角色不同，做市商在报价驱动市场中处于关键性地位，他们在市场中与投资者进行买卖双向交易；经纪人则是在交易中执行投资者的指令，并没有参与到交易中。\nD错误：2.两者的利润来源不同，做市商的利润主要来自于证券买卖差价，经纪人的利润则主要来自于给投资者提供经纪业务的佣金。\nB错误：3.对市场流动性的贡献不同，在报价驱动市场中，做市商是市场流动性的主要提供者和维持者，而在指令驱动市场中，市场流动性是由投资者的买卖指令提供的，经纪人只是执行这些指令。\nA正确：两者有时可以共同完成证券交易，当做市商之间进行资金或证券拆借时，经纪人往往是不错的帮手，有些经纪人甚至是专门服务于做市商的。"
        },
        {
            "title": "对于卖空交易，根据《上海证券交易所融资融券交易实施细则》中对标的证券的规定，以下表述错误的是（　　）。",
            "date": "202405",
            "question": "A．对股东人数有下限要求\nB．对股票价格波动幅度有上限要求\nC．对上交所上市交易时间有下限要求\nD．对股票价格有上限要求",
            "answer": "D",
            "explain": "在《上海证券交易所融资融券交易实施细则》中，上交所对于可用于融资融券的标的证券做出了详细规定，如标的证券为股票的，须符合以下7个条件：在上交所上市交易超过3个月；融资买入标的股票的流通股本不少于1亿股或流通市值不低于5亿元，融券卖出标的股票的流通股本不少于2亿股或流通市值不低于8亿元；股东人数不少于4000人；在过去3个月内没有出现日均换手率低于基准指数日均换手率的15%，且日均成交金额小于5000万元；日均涨跌幅平均值与基准指数涨跌幅平均值的偏离值超过4%；波动幅度达到基准指数波动幅度的5倍以上；股票发行公司已完成股权分置改革；股票交易未被上交所实行特别处理；上交所规定的其他条件。"
        },
        {
            "title": "某投资者通过借入所在证券公司资金购买有价证券的交易方式为（　　）。",
            "date": "202306",
            "question": "A．买空交易\nB．期货交易\nC．卖空交易\nD．现货交易",
            "answer": "A",
            "explain": "融资即投资者借入资金购买证券，也叫买空交易，故A正确；卖空交易即融券业务，与融资业务正好相反，投资者可以向证券公司借入一定数量的证券卖出，当证券价格下降时再以当时的市场价格买入证券归还证券公司，自己则得到投资收益，C错误。"
        },
        {
            "title": "关于保证金交易的说法不正确的是（　　）。",
            "date": "202405",
            "question": "A．保证金交易也称为信用交易\nB．保证金除以所投资金额或证券总价值的比率称为保证金率\nC．在我国，保证金交易被称为“融资融券”\nD．所有的证券公司都可以开展此项业务",
            "answer": "D",
            "explain": "融资融券业务会放大投资收益率或损失率，如同杠杆一样增加了投资结果的波动幅度。为防范融资融券的投资风险，证券交易所对参与融资融券的证券公司做出了严格规定，只有符合一定标准的证券公司才能开展此项业务。"
        },
        {
            "title": "基金经理下达1笔18元/股买入某只股票100万股，盘中交易员下达指令时，此股票的价格下降到17元/股，则交易员下达的价格为（　　）。",
            "date": "202302",
            "question": "A．17元\nB．18元\nC．交易员需跟基金经理反馈\nD．交易员需跟交易主管反馈",
            "answer": "A",
            "explain": "交易员接收到指令后有权根据自身对市场的判断选择合适时机完成交易。当市场价格为17元时，优于基金经理的指令，故交易员可以直接下单。"
        }, {
            "title": "关于冲击成本，以下表述错误的是（　　）。",
            "date": "202405",
            "questions": "I．冲击成本是一项隐性交易成本<br>II．冲击成本是交易行为对价格产生的影响<br>III．交易头寸越大，对市场价格的冲击越不明显<br>IV．作为一种事后计算指标，冲击成本难以精确计算",
            "question": "A．I、IV\nB．I、II\nC．III、IV\nD．III",
            "answer": "D",
            "explain": "冲击成本是一项隐性交易成本。冲击成本是交易指令下达后形成的市场价格与交易没有下达情况下市场可能的价格之间的差额。交易头寸越大，对市场价格的冲击越明显。作为一种事后计算指标，冲击成本难以精确计算。"
        },
        {
            "title": "关于交易成本，以下说法错误的是（　　）。",
            "date": "202306、202302",
            "question": "A．显性成本可以事先确定，包含佣金、税费、交易所规费三部分\nB．隐性成本包含买卖价差、冲击成本、机会成本、对冲费用等\nC．证券交易过程中的经手费、监管费、印花税等是显性成本\nD．冲击成本是购买流动性的成本，可以精确计量",
            "answer": "D",
            "explain": "AC项正确：显性成本是不包含在交易价格以内的费用支出，一般可以准确计量，也可以事先确定，又称为直接成本或价外成本。显性成本按照收费主体划分，包含经纪商佣金、税费、交易所规费/结算所规费三个主要部分。\nB项正确：隐性成本是包含在交易价格以内的、由具体交易导致的额外费用支出（相对于没有该笔交易的情形而言），一般无法准确计量，也不能事先确定，因此往往容易被忽视。隐性成本又被称为间接成本或价内成本，包含买卖价差、冲击成本、机会成本、对冲费用等。\nD项错误：冲击成本属于隐性成本，无法精确计量。"
        },
        {
            "title": "旨在下单时以尽可能接近市场按成交量加权的均价进行，以尽量降低该交易对市场的冲击的交易算法是（　　）。",
            "question": "A．执行偏差算法\nB．时间加权平均价格算法\nC．成交量加权平均价格算法\nD．跟量算法",
            "answer": "C",
            "explain": "成交量加权平均价格算法，是最基本的交易算法之一，旨在下单时以尽可能接近市场按成交量加权的均价进行，以尽量降低该交易对市场的冲击。"
        },
        {
            "title": "关于交易指令在基金公司内部的执行，以下表述错误的是（　　）。",
            "date": "202405、202302",
            "question": "A．在自主权限内，基金经理通过交易系统向交易室下达交易指令\nB．交易系统或相关负责人员审核投资指令的合法合规性，违规指令将被拦截并反馈给基金经理\nC．交易员接到任何交易指令后均必须立即完成，无权进行交易择时\nD．通过审核的投资指令才能被分发给交易员",
            "answer": "C",
            "explain": "交易员接收到指令后有权根据自身对市场的判断选择合适时机完成交易。"
        },
        {
            "title": "交易员不能有效履行对基金经理交易指令的监督、复核职责，这会产生（　　）。",
            "date": "202306、202302",
            "question": "A．操作风险\nB．信用风险\nC．市场风险\nD．投资风险",
            "answer": "A",
            "explain": "交易员不能有效履行对基金经理交易指令的监督、复核职责属于投资交易中的操作风险。"
        },
        {
            "title": "以下有关利率风险的说法错误的是（　　）。",
            "question": "A．利率变动主要受到通货膨胀、央行货币政策、经济周期、和国际利率水平的影响\nB．利率变动很少发生，因此利率风险不是一个重要的市场风险\nC．利率风险指的是因利率变化而产生的相关投资标的的交易价格的不确定性\nD．利率变动是一个积累的过程，因此利率风险具备一定的隐蔽性",
            "answer": "B",
            "explain": "利率变动经常发生，利率风险是一个重要的市场风险。"
        },
        {
            "title": "在投资风险管理中，以下不属于市场风险的是（　　）。",
            "date": "2021",
            "question": "A．购买力风险\nB．汇率风险\nC．政策风险\nD．流动性风险",
            "answer": "D",
            "explain": "市场风险包括政策风险、经济周期性波动风险、利率风险、购买力风险和汇率风险等。流动性风险和市场风险并列，都属于投资风险。"
        },
        {
            "title": "2013年6月，国内市场资金面持续紧张，资金利率一路上行，出现“钱荒”。这主要体现了投资分析中的（　　）。",
            "question": "A．操作风险\nB．政策风险\nC．流动性风险\nD．信用风险",
            "answer": "C",
            "explain": "资金的需求旺盛而供给不足视为流动性风险。"
        },
        {
            "title": "关于风险测度，以下表述正确的是（　　）。",
            "question": "A．事后风险测度用来衡量和预测目前组合在将来的表现和风险情况\nB．事前风险测度用来评价一个组合在历史上的表现和风险情况\nC．风险测度可分为事前和事后两类\nD．损失是一个事前概念",
            "answer": "C",
            "explain": "风险测度分事前和事后两类。事前风险测度是在风险发生前，衡量投资组合在未来的表现和风险情况。事后风险测度则是在风险发生后的分析，主要目的是研究投资组合在历史上的表现和风险情况，常用来衡量风险调整后的收益情况。"
        },
        {
            "title": "关于风险指标，以下表述错误的是（　　）。",
            "date": "202306、202302",
            "question": "A．投资组合的波动率是指单位时间收益率的标准差\nB．基金的波动率越高，表示基金的净值波动越剧烈，收益率不确定性越高\nC．β系数是评估投资组合系统性风险的指标\nD．β系数>0，表示投资组合的价格变动方向与市场一致，β系数不能小于0",
            "answer": "D",
            "explain": "A正确：投资组合波动率在风险管理中最常见的定义是单位时间收益率的标准差。\nB正确：基金的波动率越高，表示基金的净值波动越剧烈，收益率不确定性越高。\nC正确：系数是评估证券或投资组合系统性风险的指标，反映的是投资对象对市场变化的敏感度。\nD错误：β系数小于0时，该投资组合的价格变动方向与市场相反。"
        }, {
            "title": "关于跟踪误差，表述错误的是（　　）。",
            "date": "202302",
            "question": "A．是度量一个股票组合相对于某基准组合偏离程度的重要指标\nB．跟踪误差小，反映股票组合的跟踪偏离度小，风险低\nC．一般仅适用于主动投资管理者的业绩考核\nD．复制误差、现金流存、各项费用、分红和交易冲击成本等会导致跟踪误差产生",
            "answer": "C",
            "explain": "A正确：跟踪误差是度量一个股票组合相对于某基准组合偏离程度的重要指标。\nB正确：跟踪误差小，反映股票组合的跟踪偏离度小，风险低。\nC错误：该指标被广泛用于被动投资及主动投资管理者的业绩考核，并且这里指的业绩既可以是事前的，也可以是事后的。\nD正确：跟踪误差产生的原因有复制误差、现金留存、各项费用、分红因素和交易证券时的冲击成本等也会对跟踪误差产生影响。"
        },
        {
            "title": "关于最大回撤，表述错误的是（　　）。",
            "date": "202405、202302",
            "question": "A．基金的最大回撤与指定的时间区间长短无关\nB．某基金2020年1月2日成立，成立时基金净值为1元，净值于2月28日达到最小值0.85元，则该基金成立两个月以来的最大回撤为15%\nC．最大回撤用于衡量基金经理对下行风险的控制能力\nD．最大回撤只能衡量基金损失的大小，不能衡量损失发生的频率",
            "answer": "A",
            "explain": "A错误：最大回撤测量投资组合在指定区间内从最高点到最低点的回撤，计算结果是在选定区间内任一历史时点往后推，产品净值走到最低点时的收益率回撤幅度的最大值 。B正确：1-0.85=0.15，0.15/1*100%=15%。\nC正确：最大回撤可以在任何历史区间做测度，用于衡量投资管理人对下行风险的控制能力。指定区间越长，这个指标就越不利，因此在不同的基金之间使用该指标时,应尽量控制在同一个评估期间。\nD正确：最大回撤的缺点是只能衡量损失的大小，而不能衡量损失发生的可能频率。"
        },
        {
            "title": "风险价值（VaR）的考察区间一般为（　　）。",
            "date": "2021",
            "question": "A．短期，一般一周或几周\nB．中长期，一般一年或数年\nC．长期，十年以上\nD．中期，一般几个月至一年",
            "answer": "A",
            "explain": "VaR的考察区间通常很短（一天、一周或几周）。"
        },
        {
            "title": "关于计算VaR值的参数法，下列表述错误的是（　　）。",
            "question": "A．参数法又称为方差-协方差法\nB．该方法以风险因子收益率服从某特定类型的概率分布为假设\nC．该方法假设市场未来的变化方向与市场的历史发展状况大致相同\nD．该方法依据历史数据计算风险因子收益率分布的参数值",
            "answer": "C",
            "explain": "历史模拟法假设市场未来的变化方向与市场的历史发展状况大致相同。"
        },
        {
            "title": "在给定的时间区间和置信区间内，投资组合损失的期望值被称为（　　）。",
            "date": "202306、202302",
            "question": "A．最大回撤\nB．下行标准差\nC．预期损失\nD．风险价值",
            "answer": "C",
            "explain": "预期损失是指在给定时间区间和置信区间内，投资组合损失的期望值。"
        },
        {
            "title": "预期损失的优势体现在以下哪些方面（　　）。",
            "date": "202306",
            "questions": "I．风险救感性度量<br>II．尾部风险度量<br>III．风险因子收益<br>IV．次可加性",
            "question": "A．I、II\nB．I、III\nC．II、IV\nD．II、III",
            "answer": "C",
            "explain": "预期损失由于其在尾部风险度量、次可加性等方面的优势，越来越受到金融行业与监管机构的重视。"
        },
        {
            "title": "关于股票型基金的风险管理，以下表述错误的是（　　）。",
            "date": "202306",
            "question": "A．某股票型基金的年单边换手率为 100%，则其持有股票的平均时间为 1年\nB．某股票基金的平均市盈率和平均市净率均小于市场指数的市盈率和市净率，则该基金为成长型基金\nC．前十大重仓股占比是衡量持股集中度的指标\nD．反映股票型基金风险的指标有标准差、β系数、行业集中度、持股数量等",
            "answer": "B",
            "explain": "如果股票基金的平均市盈率、平均市净率小于市场指数的市盈率和市净率，可以认为该股票基金属于价值型基金；反之，该股票基金则可以归为成长型基金。"
        },
        {
            "title": "对于投资风险管理而言，以下哪只基金的基金经理的核心任务是管理信用风险？",
            "question": "A．上证10年期国债ETF\nB．中短债基金\nC．国债指数基金\nD．中证可转债指数基金",
            "answer": "B",
            "explain": "债券基金经理的核心任务是管理信用风险，控制基金持有的债券信用等级，并进行适度的分散化投资，避免基金对单一债券或债券类别承担过大的信用风险。"
        },
        {
            "title": "债券基金管理人为了减少债券信用风险暴露，最可能采取的直接措施是（　　）。",
            "date": "20201128",
            "question": "A．定期评估交易对手信用资质\nB．控制交易对手集中度和组合流动性\nC．不买主体经营状况不佳或信誉不高发行人发行的债券\nD．交易对手限额管理",
            "answer": "C",
            "explain": "要控制债券信用风险的最直接的办法就是不买主体经营状况不佳或信誉不高发行人发行的债券。"
        },
        {
            "title": "关于货币市场基金风险的指标，以下表述错误的是（　　）。",
            "date": "202306",
            "question": "A．融资回购比例\nB．投资组合平均剩余期限\nC．跟踪误差\nD．浮动利率债券投资情况",
            "answer": "C",
            "explain": "ABD正确：衡量货币市场基金的风险指标主要有投资组合平均剩余期和平均剩余存续期、融资回购比例、浮动利率债券投资情况以及投资对象的信用评级等。\nC错误：跟踪误差一般用于指数基金。"
        },
        {
            "title": "衡量货币市场基金的风险指标主要有（　　）。",
            "date": "202405",
            "question": "A．投资组合平均剩余期限和行业投资集中度\nB．投资组合平均剩余期限、平均剩余存续期、浮动利率债券投资情况\nC．投资组合的系数、平均剩余存续期、融资回购比例\nD．久期、β系数和投资对象的信用评级",
            "answer": "B",
            "explain": "衡量货币市场基金的风险指标主要有投资组合平均剩余期限和平均剩余存续期、融资回购比例、浮动利率债券投资情况以及投资对象的信用评级等。"
        },
        {
            "title": "混合型基金投资风险管理的主要手段是（　　）。",
            "date": "202405",
            "question": "A．调整股票、债券等大类资产的配置比例\nB．控制投资者结构\nC．选择合适的交易场所\nD．分散投资",
            "answer": "A",
            "explain": "由于混合基金的股票仓位比股票型基金和债券型基金的更灵活，针对其的风险管理也更多样化，具体可根据基金当时的股票仓位和面临的主要投资风险进行控制。"
        },
        {
            "title": "关于RQFII和QFII产品投资我国资本市场所面临的市场风险，以下表述错误的是（　　）。",
            "question": "A．均面临利率风险\nB．均面临汇率风险\nC．均面临经济波动风险\nD．均面临政策风险",
            "answer": "B",
            "explain": "RQFII是指人民币合格境外机构投资者，使用人民币；QFII是合格的境外机构投资者，在经过证监会的审核之后，境外机构投资者可以在外管局允许的额度内将外汇换成人民币进行境内投资。即RQFII不面临汇率风险，QFII面临汇率风险。"
        },
        {
            "title": "跨境投资风险中的估值风险主要有（　　）。",
            "date": "202306、202302",
            "questions": "I．多品种和多币种核算问题<br>II．基金估值核算数据来源不一致<br>III．证券交易不活跃<br>IV．各国税收制度不一致",
            "question": "A．I、II、IV\nB．I、II、III、IV\nC．I、II、III\nD．I、II",
            "answer": "B",
            "explain": "跨境业务涉及多市场、多品种和多币种的估值核算问题，基金会计估值过程中经常会遇到数据来源不一致、证券交易不活跃、各国税收制度不一样等问题，这些问题都是潜在的估值风险。"
        },
        {
            "title": "张先生拟用退休金购买基金，对基金选择，亲友们的建议有以下4点，请你从专业角度帮助张先生做出分析，正确的是（　　）。",
            "date": "202306、202302",
            "questions": "I．选择年初以来收益率高的<br>II．选择基金经理从业年限长的<br>III．选择风险调整后超额收益高的<br>IV．想清楚自己的投资目标",
            "question": "A．I、IV\nB．III、IV\nC．II、III\nD．I、II、IV",
            "answer": "B",
            "explain": "I项错误：考察的时间太短；II项错误：基金经理的从业年并不必然代表更高的收益率。"
        },
        {
            "title": "关于基金业绩评价原则，以下表述错误的是（　　）。",
            "date": "2021",
            "question": "A．基金业绩评价应着眼投资管理能力驱动的基金业绩\nB．基金业绩评价应将同类基金的风险收益交换效率进行比较\nC．基金业绩评价应遵循及时性原则，注重基金的短期表现\nD．基金业绩评价应公平对待所有评价对象",
            "answer": "C",
            "explain": "基金业绩评价应遵循长期性原则，注重基金的长期（而非短期）表现。"
        },
        {
            "title": "某基金在2015年1月1日单位净值为1.1元，2015年12月31日单位净值为1.02元，其中在2015年 8月30日该基金每份额派发红利0.2元。该基金在2015年8月29日（除息前一天）的单位净值为1.21元，则该基金在2015年全年的加权收益率为是（　　）。",
            "date": "202306",
            "question": "A．11.1%\nB．-11%\nC．-7.27%\nD．21.1%",
            "answer": "A",
            "explain": "基金在2015年全年的加权收益率=[1.21/1.1×1.02/（1.21-0.2）-1]×100%=11.1%。"
        },
        {
            "title": " 小明申购某货币市场基金并持有三年，第一年年化收益是3%，第二年年化收益是4%，第三年年化收益是5%，则小明买入该货币市场基金总收益是（　　）。",
            "date": "202302",
            "question": "A．11.52%\nB．10%\nC．12%\nD．12.48%",
            "answer": "D",
            "explain": "货币市场基金收益按复利计算总收益， 故：（ 1 + 3% ）×（1 + 4% ）×（1 + 5% ）-1 = 12.48%"
        },
        {
            "title": " 某指数型基金最近4年的收益率分别为-10%、0%、10%、30%，则该基金最近4年的平均收益率为（　　）。",
            "date": "202302",
            "question": "A．0%\nB．7.5%\nC．5%\nD．-1%",
            "answer": "B",
            "explain": "最近4年的平均收益率=（-10%+0+10%+30%）/4=7.5%"
        },
        {
            "title": " 以下关于相对收益的说法，正确的是（　　）。",
            "question": "A．组合的相对收益，指的是组合在一段评估时间内所获得的收益\nB．若组合的基准指数是下跌的， 则组合的净值也应该是下跌的\nC．若组合的基准指数是上涨的，则组合的净值也应该是上涨的\nD．组合的相对收益，可以是负值，也可以是正值",
            "answer": "D",
            "explain": "相对收益又称超额收益，基金超出业绩比较基准的收益，A错误； 若组合的基准指数是下跌/上涨的， 则组合的净值不一定是下跌/上涨的， 基准组合只是一个参照指标，B和C错误。"
        },
        {
            "title": "以下不属于风险调整后基金收益指标的是（　　）。",
            "date": "202405、 202306",
            "question": "A．詹森a\nB．信息比率\nC．夏普比率\nD．相对收益",
            "answer": "D",
            "explain": "几种常用的风险调整后收益指标包括：1.夏普比率；2.特雷诺比率；3.詹森a；4.信息比率与跟踪误差。综上，该题选D。"
        },
        {
            "title": "某基金在一段时间内平均收益率为30%，标准差为0.6，系统风险为1.2。假设短期国库券的名义收益率为6%，该基金的特雷诺比率为（　　）。",
            "date": "2021",
            "question": "A．0.288\nB．0.3\nC．0.2\nD．0.4",
            "answer": "C",
            "explain": "特雷诺比率＝（基金平均收益率－平均无风险收益率）÷系统风险＝（30%－6%）÷1.2＝0.2"
        },
        {

            "title": "关于相对收益归因和绝对收益归因，以下表述错误的是（　　）。",
            "date": "202405",
            "questions": "I．在股票投资组合的绝对收益归因分析中常用Brinson模型<br>II．绝对收益归因是对基金总收益进行分解<br>III．绝对收益归因比相对业绩归因计算更加复杂<br>IV．相对收益归因侧重分析基金如何跑输或跑赢业绩比较基准",
            "question": "A．I、III\nB．II、III\nC．I、II、III\nD．I、III、IV",
            "answer": "A",
            "explain": "Ⅰ项错误：对股票投资组合进行相对收益归因分析，最常用的是 Brinson 模型。\nII项正确：绝对收益归因是考察各个因素对基金总收益的贡献，其本质是对基金总收益的分解。\nIII项错误：相对收益归因的计算比绝对收益归因的计算更加复杂。\nIV项正确：相对收益归因侧重分析基金如何跑输或跑赢业绩比较基准。综上，该题选A。",
        },
        {
            "title": "下表是某基金以及其业绩比较基准的组合和收益情况，使用Brinson模型进行相对收益归因，可以得出该基金由于资产配置所带来的超额收益为（　　）。",
            "table": "<table border='1' width='100%'><tr><th>投资子集/基准指数</th><th>基金业绩</th><th>基金权重</th><th>基准业绩</th><th>基准权重</th></tr><tr><td>股票/沪深300</td><td>15%</td><td>85%</td><td>11%</td><td>70%</td></tr><tr><td>债券/中债综合财富指数</td><td>3%</td><td>15%</td><td>2.5%</td><td>30%</td></tr></table>",
            "date": "20180401",
            "question": "A．3.47%\nB．1.8%\nC．2.95%\nD．1.275%",
            "answer": "D",
            "explain": "资产配置带来的超额收益 = ∑[(各类资产实际权重-基准权重)×基准指数收益率] = (85%-70%)×11% + (15%-30%)×2.5% = 1.275%"
        },
        {
            "title": "关于全球投资业绩标准（GIPS）的作用以下表述正确的是（　　）。",
            "date": "202405、202306",
            "question": "A．鼓励机构仅展示业绩良好的组合\nB．让不同投资管理机构的投资业绩具有可比性\nC．当其中条约与当地法律法规有冲突时，可替代当地法律的标准\nD．GIPS仅包含一套标准",
            "answer": "B",
            "explain": "B正确、D错误：遵循GIPS可以提高业绩报告的透明度，确保在一致、可靠、公平且可比的基础上报告投资业绩数据，让不同投资管理机构的投资业绩具有可比性。\nGIPS特点：\n(1) GIPS非强制，属于自愿参与性质，并代表业绩报告的最低标准。如其中条款条约与当地法律法规有冲突，则以当地法律为准，并需将该情况进行充分披露。\n(2) GIPS标准包含两套。一套为必须遵守的规定，投资管理机构必须在全体一致遵守所有规定的情况下，方可宣称已符合标准；另一套为推荐遵守的行业最高标准。为了实现GIPS的目标，公司在符合规定的同时，也应努力遵守最高标准。\nA错误：(3) 为了防止机构仅展示业绩良好的组合，GIPS规定投资管理机构应将所有可自由支配于预期投资策略及收取管理费的组合，根据相同策略或投资目标，纳入至少一个以上的组合群。\n(1) 除成立未满5年的投资管理机构外，所有机构必须汇报至少5年以上符合GIPS的业绩，并于此后每年更新业绩，一直汇报至10年以上的业绩。公司可关联2000年1月1日之前不符合标准的业绩，但自该日起的业绩必须遵守最新的GIPS标准。例如，自2011年1月1日起的业绩标准应符合2010年的更新版本。\n(2) GIPS依赖于输入数据的真实性与准确性。投资管理机构应遵守GIPS规定的计算方式和呈现模式，并对规定内容进行充分的声明与披露。"
        },
        {
            "title": "关于场内证券交易场所，以下表述错误的是（　　）。",
            "date": "202405",
            "question": "A．证券交易所可以决定证券交易的价格\nB．证券交易所的设立和解散由国务院决定\nC．上交所和深交所都设有会员大会、理事会和专门委员会\nD．我国的证券交易所目前都采用会员制",
            "answer": "A",
            "explain": "证券交易价格是通过证券供求双方共同作用得以确定的。"
        },
        {
            "title": "证券交易所的决策机构是（　　）。",
            "date": "202302",
            "question": "A．总经理\nB．专门委员会\nC．会员大会\nD．理事会",
            "answer": "D",
            "explain": "理事会是证券交易所的决策机构，理事会下面可以设立其他专门委员会。"
        },
        {
            "title": "我国的场内证券登记结算机构是（　　）。",
            "date": "202306",
            "question": "A．上海清算所\nB．中央结算公司\nC．中国结算公司\nD．中央国债登记结算公司",
            "answer": "C",
            "explain": "中国证券登记结算有限责任公司（简称中国结算公司）是我国的证券登记结算机构。"
        },
        {
            "title": "关于证券和资金结算实行分级结算原则，以下表述错误的是（　　）。",
            "date": "202306",
            "question": "A．结算参与人负责办理结算参与人与客户之间的清算交收\nB．结算参与人与其客户的证券划付，应当委托证券登记结算机构代为办理\nC．证券登记结算机构直接办理证券登记结算机构与客户之间的清算交收\nD．证券登记结算机构负责证券登记结算机构与结算参与人之间的集中清算交收",
            "answer": "C",
            "explain": "证券和资金结算实行分级结算原则：\nD正确：证券登记结算机构作为共同对手方提供多边净额结算服务时，证券登记结算机构负责与结算参与人之间的集中清算交收，结算参与人负责与客户之间的证券和资金的清算交收；\nB正确、C错误：不作为对手方提供结算服务时，由证券登记结算机构根据结算参与机构委托，代为完成与结算参与机构之间的证券和资金的清算交收；\nA正确：结算参与机构负责办理结算参与机构与客户之间的资金的清算交收。"
        },
        {
            "title": "关于证券登记结算机构，以下描述错误的是（　　）。",
            "date": "202306",
            "question": "A．证券登记结算机构需要制定由结算参与人共同遵守的技术标准和规范\nB．证券登记结算机构负责办理结算参与人与客户之间的清算交收\nC．证券登记结算机构要对结算数据进行备份\nD．我国设立了证券结算风险基金，以防范证券结算风险",
            "answer": "B",
            "explain": "A正确：证券登记结算机构需制定由结算参与人共同遵守的技术标准和规范。\nB错误：证券登记结算机构作为共同对手方提供多边净额结算服务时，证券登记结算机构负责与结算参与人之间的集中清算交收，结算参与人负责与客户之间的证券和资金的清算交收。\nC正确：证券登记结算机构需要对结算数据和技术系统进行备份，制定业务紧急应变程序和操作流程。\nD正确：为防范证券结算风险，我国还设立了证券结算风险基金，用于垫付或弥补因违约交收、技术故障、操作失误、不可抗力等造成的证券登记结算机构的损失。"
        }, {
            "title": "关于全额结算方式，以下表述错误的是（　　）。",
            "date": "202405",
            "question": "A．证券的足额以单笔交易为最小单位，足额则全部交收，不足额不分拆交收\nB．证券登记结算机构对每笔证券交易均独立结算，同一结算参与人的应收应付资金不轧差\nC．证券登记结算机构作为买卖双方的共同对手方，提供交收担保\nD．买卖双方结算参与人任何一方应付资金或应收证券不足的，则交收失败",
            "answer": "C",
            "explain": "逐笔全额结算是指证券登记结算机构对每笔证券交易均独立结算，同一结算参与人应收资金(证券)和应付资金(证券)不轧差处理，故B正确。在交收时点，买卖双方应付资金和证券都符合要求的，完成交收；任何一方或双方结算参与人应付资金或应付证券不足的，交收失败，D正确。C错误：证券登记结算机构不作为双方的共同对手方，不提供交收担保。"
        },
        {
            "title": "以下采用净额结算方式的是（　　）。",
            "date": "2021",
            "question": "A．大宗交易\nB．股票买卖\nC．私募债券转让\nD．跨境ETF申购",
            "answer": "B",
            "explain": "ACD都采用全额结算方式，故选B。"
        },
        {
            "title": "当证券投资基金采取托管人结算模式时，其当日交易后的资金与（　　）直接交收。",
            "date": "202302",
            "question": "A．交易所\nB．托管人\nC．证券公司\nD．登记结算机构",
            "answer": "D",
            "explain": "托管人结算模式，是指托管资产场内交易形成的交收资金由托管人作为结算参与人与中国证券登记结算有限责任公司进行净额交收，然后由托管人负责与托管资产组合进行二级清算。"
        },
        {
            "title": "基金从事场内证券交易涉及的交易成本包括（　　）。",
            "date": "202306",
            "question": "A．佣金、过户费、经手费、印花税\nB．经手费、印花税、登记费、席位费\nC．佣金、证管费、备案费、印花税\nD．佣金、过户费、备案费、经手费",
            "answer": "A",
            "explain": "基金通过与券商签订交易单元租用合同，获得投资交易的路径。基金需要向券商支付交易佣金，还需要支付过户费、经手费、证管费、印花税等交易成本。"
        },
        {
            "title": "关于大宗交易，以下表述错误的是（　　）。",
            "question": "A．证券交易所可以根据市场实际情况调整大宗交易的最低额\nB．对于当天停牌的股票，沪深交易所都不接受其大宗交易申请\nC．大宗交易是指单笔数额较大的证券买卖\nD．每个交易日15:00以后，上海证券交易所开始接受大宗交易",
            "answer": "D",
            "explain": "A正确：按照规定，证券交易所可以根据市场实际情况调整大宗交易的最低额。B正确：上海证券交易所，如果在交易日15:00前处于停牌状态的证券，则不受理其大宗交易的申报。C正确：大宗交易是指单笔数额较大的证券买卖。D错误：上海证券交易所接受大宗交易的时间为每个交易日9:30-11:30、13:00-15:30。"
        },
        {
            "title": "下述选项中，不可以进行回转交易的是（　　）。",
            "date": "202405",
            "question": "A．权证交易\nB．B股\nC．债券竞价交易\nD．单市场股票型ETF",
            "answer": "D",
            "explain": "证券的回转交易是指投资者买入的证券，经确认成交后，在交收完成前全部或部分卖出。根据我国现行的有关交易制度规定，债券竞价交易和权证交易实行当日回转交易，即投资者可以在交易日的任何营业时间内反向卖出已买入但未完成交收的债券和权证；B股实行次交易日起回转交易。深圳证券交易所对专项资产管理计划收益权份额协议交易也实行当日回转交易。"
        },
        {
            "title": "某股票的前收盘价为10元，经每10股派分0.5元的现金红利后，该股票的除息参考价为（　　）元。",
            "date": "20201128",
            "question": "A．10.5\nB．10.05\nC．9.95\nD．9.5",
            "answer": "C",
            "explain": ""
        },
        {
            "title": "有关银行间债券市场做市商制度，以下表述正确的是（　　）。",
            "date": "202405、202306",
            "question": "A．做市商应对市场上所有债券进行报价\nB．做市商作为中国人民银行的对手方，与之进行债券交易\nC．做市商在银行间债券市场上以自有资金和债券与投资者进行交易\nD．做市商向投资者进行单向报价",
            "answer": "C",
            "explain": "做市商制度，是指在债券市场上，由具有一定实力和信誉的市场参与者作为特许交易商，不断向投资者报出某些特定债券的买卖价格，双向报价并在该价位上接受投资者的买卖要求，以其自有资金和债券与投资者进行交易的制度。"
        },
        {
            "title": "在整个银行间债券市场体系中，履行监督管理职责的机构是（　　）。",
            "date": "202306、202502",
            "question": "A．中国人民银行\nB．中国银保监会\nC．全国银行间同业拆借中心\nD．中央结算公司",
            "answer": "A",
            "explain": "中国人民银行履行监督管理银行间债券市场职能。"
        },
        {
            "title": "下列选项中，不属于银行间债券市场的交易品种的是（　　）。",
            "date": "",
            "question": "A．债券期货交易\nB．债券买断式回购\nC．债券远期交易\nD．债券质押式回购",
            "answer": "A",
            "explain": "期货交易属于交易所（场内）市场交易品种。"
        },
        {
            "title": "以下不属于银行间债券市场全额结算优点的是（　　）。",
            "date": "202405",
            "question": "A．降低结算本金风险\nB．降低市场参与者结算成本和相关风险\nC．每个市场参与者都可以监控自己参与的每一笔交易结算进展情况，从而评估自身对不同对手方的风险暴露\nD．有利于保存交易的稳定和结算的及时性",
            "answer": "B",
            "explain": "全额结算的优点在于：由于买卖双方是一一对应的，每个市场参与者都可监控自己参与的每一笔交易结算进展情况，从而评估自身对不同对手方的风险暴露；而且由于逐笔全额进行结算，有利于保持交易的稳定和结算的及时性，降低结算本金风险。其缺点在于会对频繁交易的做市商有较高的资金要求，其资金负担较大，结算成本较高。"
        },
        {
            "title": "关于银行间债券市场纯券过户结算方式，以下表述错误的是（　　）。",
            "date": "202405",
            "question": "A．交易方有风险，付款方无风险\nB．债券登记托管结算机构办理债券交割款项结算自行办理\nC．特点要快捷，简便\nD．是一种交易双方建立在互相了解和信任基础上的结算方式",
            "answer": "A",
            "explain": "A错误：纯券过户的结算方式对结算双方都存在风险，即对手方可能不如期交券或付款的风险，因此采用此种结算方式应谨慎选择对手方。\nBD正确：纯券过户，是指交易结算双方只要求债券登记托管结算机构办理债券交割，款项结算自行办理。这是一种交易双方建立在互相了解和信任基础上的一种结算方式，也是国外发达市场常用的一种结算方式。\nC正确：纯券过户的特点是快捷、简便，其本质是资金清算风险由交易双方承担。"
        }, {
            "title": "债券远期交易是交易双方约定在未来某一日期，以约定价格和数量买卖债券。从成立日至结算日期限可以由交易双方确定，但最长不得超过（　　）天。",
            "date": "202306",
            "question": "A．365\nB．90\nC．180\nD．360",
            "answer": "A",
            "explain": "远期交易从成交日至结算日的期限(含成交日不含结算日)由交易双方确定，但最长不得超过365天。"
        },
        {
            "title": "有关银行间债券市场的回购，以下表述不正确的是（　　）。",
            "question": "A．质押冻结期间债券的利息归出质人所有\nB．质押式回购是交易双方进行的以债券为权利质押的一种短期资金融通业务\nC．买断式回购期内，正回购方可以使用该笔债券\nD．买断式回购的期限最长不得超过365天",
            "answer": "C",
            "explain": "在买断式回购期内，该债券归逆回购方所有，逆回购方可以使用该笔债券，只要到期有足够的同种债券返还给正回购方即可。"
        },
        {
            "title": "合格境内机构投资者(QDII)开展境外证券投资业务，可以委托境外投资顾问进行境外证券投资也可以委托境外资产托管人负责境外资产托管。关于境外投资顾问或境外托管人的条件制，以下表述错误的是（　　）。",
            "date": "202302",
            "question": "A．境外托管人应受当地政府、金融或证券监管机构的监管，有足够的熟悉境外托管业务的专职人员\nB．境外投资顾问应经所在国家或地区监管机构批准从事投资管理业务\nC．境内托管人在境外设立的分支机构担任境外托管人的，可不受关于实收资本或托管规模的限制\nD．境内基金管理公司、证券公司在境外设立的分支机构担任境外投资顾问的，可不受关于管理规模的限制",
            "answer": "C",
            "explain": "境外投资顾问(简称投资顾问)是指根据基金合同为境内机构投资者境外证券投资提供证券买卖建议或投资组合管理等服务并取得收入的境外金融机构。境内机构投资者可以委托符合下列条件的投资顾问进行境外证券投资:\nB正确:(1)在境外设立，经所在国家或地区监管机构批准从事投资管理业务。\n(2)所在国家或地区证券监管机构已与中国证监会签订双边监管合作谅解备忘录，并保持着有效的监管合作关系。\n(3)经营投资管理业务达5年以上，最近一个会计年度管理的证券资产不少于100亿美元或等值货币。\n(4)有健全的治理结构和完善的内控制度,经营行为规范,最近5年没有受到所在国家或地区监管机构的重大处罚，没有重大事项正在接受司法部门、监管机构的立案调查。\nD正确:[境内基金管理公司、证券公司在境外设立的分支机构担任投资顾问的，可以不受第(3)项规定的限制。\n境内机构投资者开展境外证券投资业务时,应当由符合有关规定的资产托管机构(简称托管人)负责资产托管业务。托管人可以委托符合下列条件的境外资产托管人负责境外资产托管业务:\n(1)在中国大陆以外的国家或地区设立，受当地政府、金融或证券监管机构的监管。\n[错误:(2)最近一个会计年度实收资本不少于10亿美元或等值货币或托管资产规模不少于1000亿美元或等值货币。\nA正确:(3)有足够的熟悉境外托管业务的专职人员。\n(4)具备安全保管资产的条件。\n(5)具备安全、高效的清算、交割能力。\n(6)最近3年没有受到监管机构的重大处罚，没有重大事项正在接受司法部门、监管机构的立案调查。"
        },
        {
            "title": "（　　）是指通过对基金所拥有的全部资产及全部负债按一定的原则和方法进行估算，进而确定基金资产公允价值的过程。",
            "date": "202302、2018",
            "question": "A．基金资产估值\nB．证券投资基金\nC．共同基金\nD．单位信托",
            "answer": "A",
            "explain": "基金资产估值是指通过对基金所拥有的全部资产及全部负债按一定的原则和方法进行估算，进而确定基金资产公允价值的过程。"
        },
        {
            "title": "某基金T日末总净值8亿元，份额数8亿份。托管人在复核时，发现少记录了一笔T日确认、T+2日支付的份额赎回交易，份额为0.2亿份，金额为0.21亿元。补记该笔业务后，该基金的份额净值为（　　）。",
            "date": "202306",
            "question": "A．0.9987\nB．1.0256\nC．1.0000\nD．0.9738",
            "answer": "A",
            "explain": "基金资产净值=8-0.21=7.79亿元，基金总份额=8-0.2=7.8亿份，基金份额净值=基金资产净值÷基金总份额=7.79÷7.8=0.9987元。"
        },
        {
            "title": "某日，某基金银行存款100万元，股票投资20万元，基金投资40万元，已计提管理费2.3万元，托管费0.8万元，业绩报酬5万元，该基金当日总资产与总负债分别为（　　）。",
            "date": "2024、2023、2018",
            "question": "A．160万元，3.1万元\nB．60万元，8.1万元\nC．160万元，8.1万元\nD．60万元，3.1万元",
            "answer": "C",
            "explain": "资产=100+20+40=160万元；负债=2.3+0.8+5=8.1万元。"
        },
        {
            "title": "（　　）是基金估值的第一责任主体。",
            "date": "202405",
            "question": "A．基金经理\nB．基金托管人\nC．基金管理人\nD．其他三项都是",
            "answer": "C",
            "explain": "基金管理人是基金估值的第一责任主体。"
        },
        {
            "title": "关于估值责任，以下表述错误的是（　　）。",
            "date": "202405、202302",
            "question": "A．基金管理人在计算份额净值时参考估值工作小组意见的，则可免除其估值责任\nB．基金托管人应该审阅基金管理人采用的估值原则和程序\nC．基金托管人对基金管理人的估值结果负有复核责任\nD．基金估值的责任人是基金管理人",
            "answer": "A",
            "explain": "A错误：基金管理人和托管人在进行基金估值、计算基金份额净值及相关复核工作时，可参考基金业协会的估值指引，但是并不能免除相关责任。即使基金管理人选择服务机构进行估值，也不能免除管理人的相关责任。\nB正确：托管人在复核、审查基金资产净值和基金份额申购、赎回价格之前，应真审阅基金管理公司采用的估值原则及技术。\nCD正确：我国基金资产估值的责任人是基金管理人，基金托管人对基金管理人的估值结果负有复核责任。"
        },
        {
            "title": "目前我国开放式基金的估值频率为（　　）。",
            "date": "2021",
            "question": "A．每个自然日估值，当日披露份额净值\nB．每个交易日估值，次日披露份额净值\nC．每个自然日估值，次日披露份额净值\nD．每个交易日估值，每周披露一次份额净值",
            "answer": "B",
            "explain": "目前我国的开放式基金于每个交易日估值，并于次日公告基金份额净值，故B正确。"
        }, {
            "title": "目前我国封闭式基金的估值频率为（　　）。",
            "question": "A．每日估值，次日披露份额净值\nB．每个交易日估值，次日披露份额净值\nC．每日估值，当日披露份额净值\nD．每个交易日估值，每周披露一次份额净值",
            "answer": "D",
            "explain": "各类基金计算净值的频率是每个交易日，但披露净值的频率有差异，开放式基金每个交易日披露净值，封闭式基金每周披露净值。"
        },
        {
            "title": "关于基金估值基本原则，以下表述正确的是（　　）。",
            "date": "202306、202302",
            "question": "A．如经济环境发生重大变化，但使潜在估值调整对前一估值日的基金资产净值影响仅在0.5%的，可以不对估值进行调整\nB．采用估值技术确定投资品种公允价值时，可以先使用不可观察输入值\nC．对于估值日无报价且最近交易日后未发生影响公允价值计量的重大事件的投资品种，应采用估值技术确定公允价值\nD．对存在活跃市场且能够获取相同资产或负债报价的投资品种，估值日有报价的，除例外情况，应采用该报价确定公允价值",
            "answer": "D",
            "explain": "A错误：如经济环境发生重大变化或证券发行人发生影响证券价格的重大事件，使潜在估值调整对前一估值日的基金资产净值的影响在0.25%以上的，应对估值进行调整并确定公允价值。B错误：估值日无报价且最近交易后未发生影响公允价值计量的重大事件的，应采用最近交易日的报价确定公允价值。C错误：采用估值技术确定公允价值时，应优先使用可观察输入值，只有在无法取得相关资产或负债可观察输入值或取得不切实可行的情况下，才可以使用不可观察输入值。D正确，对存在活跃市场且能够获取相同资产或负债报价的投资品种，在估值日有报价的，除会计准则规定的例外情况外，应将该报价不加调整地应用于该资产或负债的公允价值计量。"
        },
        {
            "title": "关于交易所上市交易的投资品种估值，以下表述正确的是（　　）。",
            "date": "202405",
            "question": "A．首次公开发行股票时公司股东公开发售的股份，可以参考《证券投资基金流通受股票估值指引（试行）》进行估值\nB．交易所上市交易的可转债按当日收盘价作为估值净价\nC．交易所上市的股指期货合约以估值当日市价进行估值\nD．对交易所上市交易或挂牌转让的固定收益品种，第三方估值机构提供的估值价格与交易所收盘价存在差异的，应当采用交易所收盘价",
            "answer": "A",
            "explain": "交易所上市交易的非流通受股票和权证以其估值日在证券交易所挂牌的市价进行估值。D错误：交易所上市交易或挂牌转让的不含权固定收益品种，按照第三方估值机构提供的相应品种当日的估值净价估值，含权固定收益品种按照第三方估值机构提供的相应品种当日的唯一估值净价或推荐估值净价估值，第三方估值机构提供的估值价格与交易所收盘价存在差异的，若基金管理人认定交易所收盘价更能体现公允价值，应采用收盘价。B错误：交易所上市交易的可转换债券按当日收盘价作为估值全价。C错误：交易所上市的股指期货合约以估值当日结算价进行估值。交易所上市的不存在活跃市场的有价证券，采用估值技术确定公允价值。对交易所上市的资产支持证券品种和私募债券，鉴于其交易不活跃，各产品的未来现金流也较难确认，按成本估值。A正确：在发行时明确一定期限限售期的股票，包括但不限于非公开发行的股票、首次公开发行股票时公司股东公开发售的股份、通过大宗交易取得的带限售期的股票等，参考流通受限股票的估值指引进行估值。"
        },
        {
            "title": "某基金全持有可转债A该转债面值200元，转股价5元，票面利率为1%。(1)可转债A在T日交易所收盘价为128.22元，应计利息0.11元，当日该转债的估值全价为（　　）元。",
            "date": "202405",
            "question": "A．128.11\nB．200.11\nC．128.33\nD．128.22",
            "answer": "D",
            "explain": "交易所上市交易的可转换债券按当日收盘价作为估值全价。"
        },
        {
            "title": "某基金全持有可转债A该转债面值200元，转股价5元，票面利率为1%。(2)关于可转债A的利息核算，以下表述正确的是（　　）。",
            "question": "A．按日计提利息，当日确认为利息收入\nB．转股日进行利息核算\nC．可转债付息日进行利息核算\nD．可转债不进行利息核算",
            "answer": "A",
            "explain": "各类资产利息均应按日计提，并于当日确认为利息收入。"
        },
        {
            "title": "以下不符合暂停估值条件的是（　　）。",
            "date": "202405",
            "question": "A．基金投资所涉及的证券交易所遇法定节假日或因其他原因暂停营业时。\nB．如出现基金管理人认为属于紧急事故的任何情况，会导致基金管理人不能出售或评估基金资产的。\nC．基金中某个投资品种的估值出现了重大转变\nD．因不可抗力或其他情形致使基金管理人、基金托管人无法准确评估基金资产价值时。",
            "answer": "C",
            "explain": "当基金有以下情形时，可以暂停估值：\nA正确：(1)基金投资所涉及的证券交易所遇法定节假日或因其他原因暂停营业时。\nD正确：(2)因不可抗力或其他情形致使基金管理人、基金托管人无法准确评估基金资产价值时。\nC错误：(3)占基金相当比例的投资品种的估值出现重大转变，而基金管理人为保障投资人的利益已决定延迟估值。\nB正确：(4)如出现基金管理人认为属于紧急事故的任何情况，会导致基金管理人不能出售或评估基金资产的。(5)中国证监会和基金合同认定的其他情形。"
        },
        {
            "title": "某只基金未使用公允价值对资产进行估值，造成了估值错误。关于该估值错误，以下表述正确的是（　　）。",
            "date": "202302",
            "questions": "I．若该错误对基金价值的影响不超过0.25%，则可以根据重要性原则予以忽略<br>II．若基金资产公允价值低于估值价格，则该估值错误对持有人更有利<br>III．若基金资产公允价值比估值价格高，则该估值错误对申购的投资者更有利<br>IV．管理人应当立即调整估值模型，以使用最新的资产价格进行估值",
            "question": "A．I、II、III、IV\nB．III、IV\nC．I、IV\nD．II、III",
            "answer": "D",
            "explain": "I项错误，当估值或资产净值计价错误实际发生时，基金管理人应立即纠正，及时采取合理措施防止损失进一步扩大。IV项错误，应当根据具体投资品种的估值方法，不一定是最新价格。综上，该题选D。"
        }, {
            "title": "某公司有两只基金，债券基金A和股票基金B，前一日A基金资产净值是100亿，当日基金资产净值为99亿，A基金的年管理费率为0.75%；B基金前一日基金资产净值是50亿，当日基金资产净值为52亿，B基金的年管理费率为1.5%，当年天数365天，则当日A基金和B基金计提的管理费（　　）。",
            "date": "202306",
            "question": "A．相同\nB．A基金计提的管理费多于B\nC．B基金计提的管理费多于A\nD．无法确定",
            "answer": "A",
            "explain": "基金A的管理费=100x0.75%/365=基金B的管理费用=50x1.5%/365"
        },
        {
            "title": "不属于在基金销售过程中发生的费用是（　　）。",
            "date": "2021",
            "question": "A．基金转换费\nB．销售服务费\nC．申购费\nD．赎回费",
            "answer": "B",
            "explain": "基金销售过程中发生的由基金投资者自己承担的费用，主要包括申购费、赎回费及基金转换费。销售服务费是在基金管理过程中发生的费用。"
        },
        {
            "title": "关于基金会计主体，以下表述错误的是（　　）。",
            "date": "202306",
            "question": "A．证券投资基金的管理主体即基金管理公司的经营活动是证券投资基金的会计核算的主要内容之一\nB．基金会计的责任主体是对基金进行会计核算的基金管理人和基金托管人\nC．基金管理公司管理的不同基金之间的投资管理活动要区别开来\nD．作为基金会计主体，基金管理人承担主要会计责任，基金托管人对基金管理人的会计核算进行复核并出具复核意见",
            "answer": "A",
            "explain": "证券投资基金的管理主体即基金管理公司，但基金公司的经营活动不是证券投资基金的会计核算的主要内容之一。"
        },
        {
            "title": "我国基金会计年度为公历（　　）。",
            "date": "202405",
            "question": "A．每年1月1日至6月30日\nB．每年6月30日至12月31日\nC．每年1月1日至次年1月1日\nD．每年1月1日至12月31日",
            "answer": "D",
            "explain": "我国基金的会计年度为公历每年1月1日至12月31日。基金核算以人民币为记账本位币，以人民币元为记账单位。"
        },
        {
            "title": "对基金会计核算内容进行复核并出具复核意见的是（　　）。",
            "question": "A．基金份额持有人\nB．基金管理人\nC．基金监督管理机构\nD．基金托管人",
            "answer": "D",
            "explain": "基金托管人对基金会计核算内容进行复核并出具复核意见。"
        },
        {
            "title": "关于基金财务会计报告分析的目的，以下表述错误的是（　　）。",
            "question": "A．预测基金未来的发展趋势\nB．评价基金未来的经营业绩及投资管理能力\nC．通过分析基金现时的资产配置及投资组合状况来了解基金的投资状况\nD．为基金投资人的投资决策提供依据",
            "answer": "B",
            "explain": "基金财务会计报告分析可以回顾过往的业绩，但不能预测未来的业绩，也无法反应未来的经营能力。"
        },
        {
            "title": "在基金收入中，股利收入属于（　　）。",
            "date": "202405",
            "question": "A．其他收入\nB．投资收益\nC．公允价值变动损益\nD．利息收入",
            "answer": "B",
            "explain": "B正确：投资收益包括股票投资收益、债券投资收益、资产支持证券投资收益、衍生工具收益和【股利收益】。\nACD错误：基金收入包括利息收入、投资收益、公允价值变动损益和其他收入。利息收入包括存款利息收入、债券利息收入、资产支持证券利息收入和买入返售金融资产收入。"
        },
        {
            "title": "2016年，某基金投资收益1.3亿元，公允价值变动损益9000万元，利息收入2900万元，其他收入200万元，则该基金当年的已实现收益是（　　）。",
            "date": "202405、2023",
            "question": "A．1.61亿元\nB．2.51亿元\nC．2900万元\nD．1.3亿元",
            "answer": "A",
            "explain": "本期已实现收益指基金本期利息收入、投资收益、其他收入(不含公允价值变动损益)扣除相关费用后的余额，是将本期利润扣除本期公允价值变动损益后的余额，反映基金本期已经实现的损益。公允价值变动9000万不属于已实现的收益。故已实现收益=1.3+0.29+0.02=1.61亿。"
        },
        {
            "title": "小王于2017年10月20日(周五)赎回了某公募货币市场基金，他应享受的利润日包含（　　）。",
            "date": "202405、2022、2018",
            "question": "A．2017年10月20日、21日\nB．2017年10月20日\nC．2017年10月20日、21日、22日\nD．2017年10月20日、21日、22日、23日",
            "answer": "C",
            "explain": "货币市场基金每周五进行分配时，将同时分配周六和周日的利润；每周一至周四进行分配时，则仅对当日利润进行分配。对于普通的货币市场基金品种，投资者于周五申购或转换转入的基金份额不享有周五和周六、周日的利润，投资者于周五赎回或转换转出的基金份额享有周五和周六、周日的利润。所以本题中10月20日(周五)赎回，享有10月21日(周六)和10月22日(周日)的利润。"
        },
        {
            "title": "关于封闭式基金利润分配，以下表述正确的是（　　）。",
            "date": "202405",
            "question": "A．利润分配可能导致封闭式基金份额数据发生变化\nB．利润分配一定会导致现金流出封闭式基金\nC．不同投资者持有相等数量的某封闭式基金份额，在某次利润分配中所分得现金可能不相等\nD．利润分配不会影响封闭式基金的份额净值",
            "answer": "B",
            "explain": "封闭式基金只能采取现金分红，不会导致基金份额数的变化，会导致现金流出基金，基金份额净值降低。"
        },
        {
            "title": "关于基金份额分拆与合并，下列表述错误的是（　　）。",
            "date": "202405",
            "question": "A．当基金的净值过低时，通过基金份额的合并可以提高其净值，这种行为被称为逆向分拆\nB．基金份额的分拆可以降低投资者对价格的敏感性，有利于基金持续营销\nC．基金份额分拆通过直接调整基金份额数量达到降低基金份额净值的目的，并不影响基金的已实现收益、未实现利得等\nD．当基金的净值过高时，通过基金份额的合并可以降低其净值",
            "answer": "D",
            "explain": "A正确、D错误：基金分拆行为是相对的，当基金的净值过高时，通过基金份额的分拆可以降低其净值；当基金的净值过低时，通过基金份额的合并可以提高其净值，这种行为通常称为逆向分拆。\nB正确：基金分拆可以降低投资者对价格的敏感性，有利于基金持续营销，有利于改善基金份额持有人结构，有利于基金经理更为有效的运作资金，从而贯彻基金运作的投资理念与投资哲学。\nC正确：基金份额分拆通过直接调整基金份额数量达到降低基金份额净值的目的，但并不影响基金的已实现收益、未实现利得等。"
        }, {
            "title": "关于基金分红与基金分拆，以下表述错误的是（　　）。",
            "date": "202306",
            "question": "A．现金分红的投资者在获得现金分红时，其基金份额并没有变化，但基金分拆的投资者的基金份额却有较大变化\nB．基金分红不需要严格的时机选择，而基金分拆则需要进行时机选择\nC．基金分红有时需要卖出部分基金资产，而基金分拆却不需要\nD．基金分红会造成大量的现金流出基金资产，而基金分拆却不会",
            "answer": "B",
            "explain": "基金分拆和基金分红还是有很大区别的：A正确：一是选择现金分红方式的投资者在获得现金分红的同时，其所拥有的基金份额并不发生改变。D正确：二是在这样的情况下，基金分红有大量的现金流出，基金的资产规模也会发生改变。B错误、C正确：三是基金分红时机的选择与基金分拆时机的选择有所不同。由于基金分红导致大量的资金流出，无论是对投资者还是基金的管理者来说，基金要进行分红必须选择一个恰当的时机。基金的分拆不需要卖出基金的资产，只是对原有的结构进行形式上的分解，对时机的要求没有那么严格。"
        },
        {
            "title": "某基金分红前的总净值为7,500万元，份额数为5000万份。该基金计划每10份份额派0.15元红利，形式为分红再投资，则本次分红后，基金的总净值和份额净值分别为（　　）。",
            "date": "202405",
            "question": "A．7425万元，1.5000元\nB．7500万元，1.5000元\nC．7425万元，1.4850元\nD．7500万元，1.4850元",
            "answer": "D",
            "explain": "基金采取分红再投资方式，没有现金流出，总净值不变，总份额数增加，份额净值降低。新的份额净值=旧的份额净值1.5元-0.015元=1.485元。"
        },
        {
            "title": "投资者买入股票 10000股需缴纳的税费不包括（　　）。",
            "date": "202405",
            "question": "A．证券交易监管费\nB．印花税\nC．过户费\nD．经手费",
            "answer": "B",
            "explain": "证券交易印花税只对出让方按0.1%征收，对受让方不再征收。"
        },
        {
            "title": "根据当前中国内地税收政策，投资者进行以下投资活动，需要缴纳增值税的是（　　）。",
            "date": "202405",
            "question": "A．合格境外投资者(QFII)委托境自公司在境内买卖股票\nB．中国内地个人投资者买卖境内基金\nC．中国内地机构投资者买卖境内基金份额\nD．香港市场机构投资者通过基金互认买卖境内基金份额",
            "answer": "C",
            "explain": "根据《营业税改征增值税试点有关事项的规定》，机构投资者买卖基金份额属于金融商品转让，应按照卖出价扣除买入价后的余额为销售额计征增值税。根据《营业税改征增值税试点过渡政策的规定》，个人买卖基金份额的行为免征增值税。根据《营业税改征增值税试点过渡政策的规定》，合格境外投资者(QFII)委托境内公司在我国从事证券买卖业务、香港市场投资者通过基金互认买卖内地基金份额取得的收入免征增值税。综上，该题选C。"
        }, {
            "title": "2019年6月12日某投资者以5元买入A股票1000股，并以20元价格卖出B股票5000股，该投资者缴纳的印花税为（　　）元。",
            "date": "202302",
            "question": "A．100\nB．210\nC．105\nD．200",
            "answer": "A",
            "explain": "目前，我国A股印花税税率为单边征收（只在卖出股票时征收），税率为1‰。因此本题中，买入A股1000股不收印花税，卖出B股5000股印花税20×5000×1‰=100（元）"
        },
        {
            "title": "申请QDII资格的基金管理公司，应该财务稳健，资信良好，资产管理规模、经营年限等符合中国证监会规定。关于此项规定，以下表述正确的是（　　）。",
            "question": "A．基金管理公司净资本不少于7亿元人民币，经营集合资产管理计划业务7年以上，最近一个季度末资产管理规模不少于200亿元人民币或等值外汇资产\nB．基金管理公司净资本不少于8亿元人民币，经营集合资产管理计划业务1年以上，最近一个季度末资产管理规模不少于20亿元人民币或等值外汇资产\nC．基金管理公司净资产不少于8亿元人民币，经营证券投资基金管理业务1年以上，最近一个季度末资产管理规模不少于20亿元人民币或等值外汇资产\nD．基金管理公司净资产不少于2亿元人民币，经营证券投资基金管理业务2年以上，最近一个季度末资产管理规模不少于200亿元人民币或等值外汇资产",
            "answer": "D",
            "explain": "申请成为QDII基金的机构投资者应当符合下列条件：申请人的财务稳健，资信良好，资产管理规模、经营年限等符合中国证监会的规定。对基金管理公司而言，净资产不少于7亿元人民币，经营证券投资基金管理业务1年以上，在最近一个季度末资产管理规模不少于200亿元人民币或等值外汇资产。"
        },
        {
            "title": "QDII开展境外证券投资业务，应当由（　　）资产托管机构负责资产托管业务，可委托（　　）证券服务机构代理买卖证券。",
            "date": "2021",
            "question": "A．境外、境外\nB．境内、境外\nC．境外、境内\nD．境内、境内",
            "answer": "B",
            "explain": "合格境内机构投资者（QDII）开展境外证券投资业务，应当由境内资产托管机构负责资产托管业务，可以委托境外证券服务机构代理买卖证券。"
        },
        {
            "title": "关于合格境内机构投资者(QDII)开展境外证券投资业务，以下表述错误的是（　　）。",
            "date": "202306、202302",
            "question": "A．可以委托境外证券服务机构代理买卖证券\nB．应当由境内资产托管机构负责资产托管业务\nC．境内托管人可以委托境外资产托管机构负责境外资产托管，境外托管人因其本身过错、疏忽导致基金财产受损的，由该境外托管人向QDII承担相应责任\nD．可以委托境内基金管理公司在境外设立的分支机构担任投资顾问",
            "answer": "C",
            "explain": "对基金、集合计划的境外财产，托管人可授权境外托管人代为履行其承担的受托人职责。境外托管人在履行职责过程中，因本身过错、疏忽等原因而导致基金、集合计划财产受损的，托管人应当承担相应责任。"
        },
        {
            "title": "沪港通的开通，在内地与香港之间搭建起资本流通的桥梁。沪港通的双向交易所采用的结算单位是（　　）。",
            "date": "202405、202306、202302",
            "question": "A．人民币或港币\nB．美元\nC．港币\nD．人民币",
            "answer": "D",
            "explain": "沪港通和深港通的双向交易均以人民币作为结算单位，这在一定程度上促进了人民币的交投量与流转量增加，为人民币国际化打下坚实的基础。"
        },
        {
            "title": "关于中国基金国际化，以下表述错误的是（　　）。",
            "date": "202306、202302",
            "question": "A．港股通为内地人民币资产配置提供了更加丰富的选择\nB．基金互认是基金跨市场销售的一种制度安排\nC．开放香港与其他国家和地区的境外投资者购买内地证券属于“北向通”\nD．QDII是我国证券市场除了基金公司、证券公司、信托公司之外的另一类重要机构投资者",
            "answer": "D",
            "explain": "QFII成为我国证券市场除了基金公司、证券公司、信托公司之外的另一类重要机构投资者。"
        },
        {
            "title": "（　　）是基金跨市场销售的一种制度性安排，即在这种制度下，在一国（地区）监管体系下注册的基金，不需要在另一个国家或地区都进行注册，或履行一定简便程序后，就可以直接销售。",
            "date": "202302",
            "question": "A．基金互认\nB．基金代销\nC．基金包销\nD．基金承销",
            "answer": "A",
            "explain": "基金互认是基金跨市场销售的一种制度性安排，即在这种制度下，在一国（地区）监管体系下注册的基金，不需要在另一个国家或地区都进行注册，或履行一定简便程序后，就可以直接销售。"
        }
    ]
}


// WEBPACK FOOTER //
// ./src/utils/fund/2025/jjjc.js